module.exports = {
  // заглушка если текста нет
  ' ': ' ',

  DELETE_PARTICIPANT: 'Delete participants',

  'country.AZ': 'Azerbaijan',
  'country.AM': 'Armenia',
  'country.BY': 'Belarus',
  'country.BE': 'Belgium',
  'country.BG': 'Bulgaria',
  'country.GB': 'Great Britain',
  'country.DE': 'Germany',
  'country.IL': 'Israel',
  'country.IN': 'India',
  'country.IT': 'Italy',
  'country.KZ': 'Kazakhstan',
  'country.CY': 'Cyprus',
  'country.KG': 'Kyrgyzstan',
  'country.KR': 'Korea',
  'country.LB': 'Lebanon',
  'country.LT': 'Lithuania',
  'country.LV': 'Latvia',
  'country.RU': 'Russia',
  'country.RO': 'Romania',
  'country.US': 'USA',
  'country.SA': 'Saudi Arabia',
  'country.TJ': 'Tajikistan',
  'country.TH': 'Thailand',
  'country.TQ': 'Turkey',
  'country.UZ': 'Uzbekistan',
  'country.UA': 'Ukraine',
  'country.FR': 'France',
  'country.CH': 'Switzerland',
  'country.SE': 'Sweden',
  'country.EE': 'Estonia',
  'country.CN': 'China',
  'country.TW': 'Taiwan',
  'country.CA': 'Canada',
  'country.MY': 'Malaysia',
  'country.HK': 'Hong Kong',
  'country.VN': 'Vietnam',
  'country.PS': 'Palestine',
  'country.EG': 'Egypt',
  'country.JO': 'Jordan',
  'country.IQ': 'Iraq',
  'country.IR': 'Iran',
  'country.AE': 'UAE',
  'country.AU': 'Australia',
  'country.ZA': 'South Africa',

  // start sign in
  'signin.title': 'Sign in',
  'signin.subtitle': 'Enter your data',
  'signin.password_old': 'Current Password',
  'signin.password_new': 'New Password',
  'signin.password_confirm': 'Confirm New Password',
  'signin.btn_title': 'Login',
  'signin.repeat':
    'Registration is not confirmed. Follow the instructions in the email. {repeat} the confirmation email',
  // end sign in

  // start sign up
  'signup.title': 'Registration',
  'signup.subtitle': 'Enter Details',
  'signup.btn_title': 'Register',
  INVALID_TOKEN: 'Invalid verification code.',
  VALIDATION_EMAIL_ALREADY_EXIST: 'This email address is already registered.',
  VALIDATION_EMAIL_ALREADY_USED: 'This email is already in use',
  'signup.success_message':
    "A confirmation email has been sent to the provided address. If you don't receive it, please return to the registration page to re-enter your details or contact technical support.",
  // end sign up

  // start verify
  'verify.success_message': 'You have successfully registered. To log in, ',
  'verify.success_message_link': 'enter your credentials',
  // end verify

  // start resend
  'resend.success_message': 'Email has been sent',
  // end resend
  // start logout
  'logout.title': 'Log Out',
  'logout.success_message': 'You have been logged out',
  // end logout

  // start forgot-password
  'forgotPassword.title': 'Forgot Password?',
  'forgotPassword.subtitle': 'Create a new one to access your account',
  'forgotPassword.btn_title': 'Submit',
  'forgotPassword.success_message':
    "A password reset link has been sent to your email. If you don't receive it, please return to the password reset page and try again, or contact technical support.",
  // end forgot-password

  // start reset-password
  'resetPassword.title': 'Password Reset',
  'resetPassword.btn_title': 'Reset Password',
  'resetPassword.success_message': 'Your password has been successfully reset.',
  // end reset-password

  // start page ChangePassword
  'changePassword.title': 'Change Password',
  'changePassword.btn_title': 'Change',
  'changePassword.success_message':
    'Password changed successfully. Please memorize it or write it down.',
  // end page ChangePassword

  // start page Home
  'home.title': 'WELCOME MESSAGE AND IMAGES WILL APPEAR HERE',
  // end page Home

  // start page NotFound
  'notFound.title': 'Error 404',
  'notFound.subtitle': 'Page not found',
  // end page NotFound

  // start page Forms
  'form.email': 'Email',
  'form.password': 'Password',
  'form.password_old': 'Current Password',
  'form.password_new': 'New Password',
  'form.confirm_password': 'Confirm Password',
  'form.agree': 'I agree to ....',
  'form.code': 'Verification Code',
  'form.error_required': 'Required',
  'form.error_invalid_email': 'Invalid email address',
  'form.error_invalid_phone': 'Invalid phone number (11 digits required)',
  'form.error_password_min': 'At least {min} characters',
  'form.error_password_letters': 'Must contain letters',
  'form.error_password_num': 'Must contain numbers',
  'form.error_password_match': 'Passwords do not match',

  // end page Forms

  // common word
  'common.repeat': 'Retry',
  'common.success_message': 'Success',
  // end cpmmom word

  // SUCCES_USER_UPDATE: "Пользователь успешно "
  'notice.success': 'Success',
  SAVED: 'Saved',

  // Validate
  MUST_BE_CONTAINS_LETTERS: 'Password must contain at least 1 Latin letter',
  MUST_BE_CONTAINS_NUMBER: 'Password must contain numbers',
  MUST_BE_7_CHARACTERS_OR_MORE: 'Password must be 7 characters or longer',
  MUST_BE_4_CHARACTERS_OR_MORE: 'Password must be 4 characters or longer',
  MUST_BE_NUMERIC: 'Must be a number',
  MUST_BE_POSITIVE: 'Amount must be greater than 0',
  REQUIRED: 'This field is required',
  PASSWORD_DO_NOT_MATCH: "Passwords don't match",
  INVALID_EMAIL_ADDRESS: 'Invalid email address',
  UNACCEPTABLE_SIGNS: 'Invalid characters or spaces',
  INVALID_DATE: 'Date must be in DD.MM.YYYY format',
  TIMETABLE_ERROR: 'Please specify the task schedule',
  // end Validate

  // Errors
  INVALID_LOGIN_DATA: 'Incorrect email or password',
  CANNOT_FOUND_USER_WITH_THIS_EMAIL: 'User with this email not found',
  INVALID_OLD_PASSWORD: 'Incorrect current password',
  EMPTY_OR_VERY_SHORT_PASSWORD: 'Password missing or too short',
  // End errors

  // Stub
  simulators: 'Training simulators',
  stub1: 'Reference materials', // ??
  reports: 'Reports',
  // End Stub
  // Главный фильтр (Правило)
  RULE_SIMPLE_SUM: 'Direct counting',
  RULE_FIVE_SUM: "5's Formulas",
  RULE_TEN_SUM: "10's Formula",
  RULE_FIVE_AND_TEN_SUM: "5's and 10's Formulas",
  NO_MODE: 'Random',

  // Главный фильтр

  // Меню
  DIRECTORY: 'Directory',
  ARCHIVE: 'Archive',

  // Student
  // Table
  STUDENT_TITLE: 'Students',
  STUDENT_TITLE_SINGULAR: 'Student',
  STUDENT_FORM_LEFT_PATH_TITLE: 'Student details',
  STUDENT_FORM_RIGTH_PATH_TITLE: 'Parent details',
  STUDENT_TABLE_CREATE_TITLE: 'Add new student',
  STUDENT_TABLE_SAVE_TITLE: 'Edit student information',
  STUDENT_TABLE_CREATE: 'Students without teacher',
  STUDENT_TABLE_INVITE: 'Send invitation',
  STUDENT_TABLE_REGISTER: 'Register student',
  STUDENT_TABLE_SAVE: 'Save',
  STUDENT_ADD: 'Add student',
  STUDENT_SUCCESS_CREATE_MESSAGE: 'Student added',
  STUDENT_SUCCESS_SAVE_MESSAGE: 'Student information updated successfully',

  // Group
  GROUP_TITLE: 'Groups',
  GROUP_TITLE_SINGULAR: 'Group',
  GROUP_FORM_LEFT_PATH_TITLE: 'Basic fields',
  GROUP_FORM_RIGHT_PATH_TITLE: 'Additional fields',
  GROUP_TABLE_CREATE_TITLE: 'Add new group',
  GROUP_TABLE_SAVE_TITLE: 'Edit group information',
  GROUP_TABLE_CREATE: 'Add',
  GROUP_TABLE_SAVE: 'Save',
  GROUP_SUCCESS_CREATE_MESSAGE: 'Group added',
  GROUP_SUCCESS_SAVE_MESSAGE: 'Group updated successfully',

  // School
  // Table
  SCHOOL_TITLE: 'Schools',
  SCHOOL_FORM_LEFT_PATH_TITLE: 'School administrator details',
  SCHOOL_FORM_RIGHT_PATH_TITLE: 'School information',
  SCHOOL_TABLE_CREATE_TITLE: 'Add new school',
  SCHOOL_TABLE_SAVE_TITLE: 'Edit school information',
  SCHOOL_TABLE_CREATE: 'Add',
  SCHOOL_TABLE_SAVE: 'Save',
  SCHOOL_SUCCESS_CREATE_MESSAGE: 'School added',
  SCHOOL_SUCCESS_SAVE_MESSAGE: 'School information updated successfully',
  SCHOOL_INFO: 'School information',

  // Teacher
  // Table
  TEACHER_TITLE: 'Teachers',
  TEACHER_FORM_LEFT_PATH_TITLE: 'Basic fields',
  TEACHER_FORM_RIGHT_PATH_TITLE: 'Additional fields',
  TEACHER_TABLE_CREATE_TITLE: 'Add new teacher',
  TEACHER_TABLE_SAVE_TITLE: 'Edit teacher information',
  TEACHER_TABLE_CREATE: 'Add',
  TEACHER_TABLE_SAVE: 'Save',
  TEACHER_SUCCESS_CREATE_MESSAGE: 'Teacher added',
  TEACHER_SUCCESS_SAVE_MESSAGE: 'Teacher information updated successfully',

  // Homework
  // Table
  HOMEWORK_TITLE: 'Homework',
  HOMEWORK_TITLE_SETTINGS: 'Homework Settings',
  HOMEWORK_TITLE_SINGULAR: 'Homework Assignment',
  HOMEWORK_FORM_LEFT_PATH_TITLE: 'Parameter Settings',
  HOMEWORK_FORM_RIGHT_PATH_TITLE: 'User Settings',
  HOMEWORK_TABLE_CREATE_TITLE: 'Create',
  HOMEWORK_TABLE_SAVE_TITLE: 'Edit',
  HOMEWORK_TABLE_CREATE: 'Create',
  HOMEWORK_TABLE_SAVE: 'Save',
  HOMEWORK_SUCCESS_CREATE_MESSAGE: 'Homework assignment(s) added',
  HOMEWORK_SUCCESS_SAVE_MESSAGE: 'Homework assignment updated successfully',
  HOMEWORK_STARTED_CARRY_OUT: 'Started working on assignment',
  LAST_WEEK_DATES:
    'Graded homework is displayed for a 7-day period based on completion date',

  // Table
  EXAMS_TITLE: 'Exam',
  EXAMS_TITLE_SINGULAR: 'Exam',
  EXAMS_FORM_LEFT_PATH_TITLE: 'Exam Parameters',
  EXAMS_FORM_RIGHT_PATH_TITLE: 'Exam Statistics',
  EXAMS_TABLE_CREATE_TITLE: 'Add New Exam',
  EXAMS_TABLE_SAVE_TITLE: 'Edit Exam',
  EXAMS_TABLE_CREATE: 'Create',
  EXAMS_TABLE_SAVE: 'Save',
  EXAMS_SUCCESS_CREATE_MESSAGE: 'Exam created successfully',
  EXAMS_SUCCESS_RESULT: 'Exam results saved successfully',
  EXAMS_SUCCESS_SAVE_MESSAGE: 'Exam data updated successfully',
  EXAM_SUCCESS_SAVE: 'Link saved successfully',

  // Book
  // Table
  WORKBOOK_BUTTON: 'Generate samples',
  WORKBOOK_TITLE: 'Printable samples',
  CERTIFICATION_TITLE: 'Certification',
  CERTIFICATION_SIMULATE_TITLE: 'Simulation',
  SIMULATE_PAUSE: 'Competition simulation paused. Please wait',
  CERTIFICATION_SIMULATE_SAMA_TITLE: 'SAMA GLOBAL Simulation',
  CERTIFICATION_SIMULATE_PAMA_TITLE: 'PAMA GLOBAL Simulation',
  CERTIFICATION_SIMULATE_UAMAP_TITLE: 'UAMAP Simulation',
  CERTIFICATION_EXAM_TITLE: 'Exam',
  BOOK_TITLE: 'Teamwork',
  WORKBOOK_TO_PRINT: 'Send to Printer',

  CAR_ICON: 'Car',
  PLANE_ICON: 'Airplane',
  ELEPHANT_ICON: 'Baby Elephant',
  HELICOPTER_ICON: 'Helicopter',
  TIGER_ICON: 'Tiger Cub',
  FOX_ICON: 'Fox Cub',
  FAWN_ICON: 'Fawn',
  CROCODILE_ICON: 'Crocodile',
  SQUIRREL_ICON: 'Baby Squirrel',
  BEAR_ICON: 'Teddy Bear',
  WOLF_ICON: 'Wolf Cub',
  LEOPARD_ICON: 'Leopard',

  COLUMN: 'Columns',
  SIMULATORS: 'Trainers',
  EDIT_PROFILE: 'Edit Profile',
  EXIT_INSIDE_PROFILE: 'Exit',
  NAME: 'Name',
  SURNAME: 'Surname',
  NAME_EN: 'Name (English)',
  SURNAME_EN: 'Surname (English)',
  SEX: 'Gender',
  MIDDLE_NAME: 'Middle Name',
  STATUS: 'STATUS',
  TRANSACTION_STATUS: 'Status',
  EXAM_LINK: 'Yandex Link',
  CITY: 'City',
  EMAIL: 'Email Address',
  EMAIL_SHORT: 'Email',
  PHOTO_LINK: 'Participant Photo Link',
  MAIN_PAGE_ROOMA_TITLE: 'Quick Access: Anzan',
  MAIN_PAGE_ROOMA_DESCRIPTION:
    'In this section you can view and improve your skills',
  MAIN_PAGE_ROOMB_TITLE: 'Quick Access: Columns',
  MAIN_PAGE_ROOMB_DESCRIPTION:
    'In this section you can view and improve your skills',
  MAIN_PAGE_ROOMC_TITLE: 'Quick Access: Flash Cards',
  MAIN_PAGE_ROOMC_DESCRIPTION:
    'In this section you can view and improve your skills',
  DETAIL: 'More Details...',
  SET_YOUR_DATE_OF_BIRTH: 'enter your date of birth',
  ROLE_GUEST: 'Unauthorized',
  ROLE_STUDENT: 'Student',
  ROLE_TEACHER: 'Teacher',
  ROLE_SCHOOL: 'School',
  ROLE_ADMIN: 'Administrator',
  ROLE: 'User Type',
  CABINET: 'Dashboard',
  SETTINGS: 'Settings',
  BASIC_SETTINGS: 'Basic Settings:',
  ADDITIONAL_SETTINGS: 'Detailed Settings:',
  TRAINER_SETTINGS: 'Trainer Settings',
  room: 'Room',
  amount: 'Number of samples',
  OLIMPIC_SAMPLES_TITLE: 'samples',
  section: 'Section',
  animation: 'Animation',
  windows: 'Number of Screens',
  simulator: 'Trainer',
  steps: 'Number of operands',
  period: 'Pause between samples',
  INTERVAL: 'Display Speed',
  interval: 'Display Speed',
  ACTIVATE_NEGATIVE: 'Enable negative numbers',
  NEGATIVE_ANSWER: 'Negative final answer',
  mode: 'Theme',

  sign: 'Sign',
  bound: 'Transition',
  under: 'from',
  over: 'to',
  of: 'of',
  rule: 'Rule',
  numbers: 'Section',
  formulas: 'Formula(s) for number(s):',
  formulas_once: 'Formula(s):',
  student: 'Student',
  students: 'Student(s)',
  individ: 'Individually',
  date: 'Date',
  dates: 'Date(s)',
  daily: 'Daily',
  daily_over: 'Daily until',
  numbers_of_terms: 'Number of operands',
  numbers_in_example: 'Number of operands in sample',
  comment: 'Comment',
  first_int_available_numbers: 'First multiplier',
  second_int_available_numbers: 'Second multiplier',
  order_first_int_available_numbers: 'First multiplier place value',
  order_second_int_available_numbers: 'Second multiplier place value',

  DIVISION: 'Division',
  MULTIPLICATION: 'Multiplication',
  MULTIDIVISION: 'Multiplication/Division',
  divider: 'Divisor',
  dividend: 'Dividend',

  // Animation Types
  FADING: 'Fading',
  SLIDE_UP: 'Slide up',
  SLIDE_DOWN: 'Slide down',
  SLIDE_LEFT: 'Slide left',
  SLIDE_RIGHT: 'Slide right',
  BIGGER_FONT: 'Larger font',
  SMALLER_FONT: 'Smaller font',
  RANDOM_PLACE: 'Random position',
  MULTICOLORED_NUMBERS: 'Multicolored numbers',
  NO_ANIMATIONS: 'No animations',

  // Training Rooms
  roomA: 'Anzan',
  roomB: 'Columns',
  roomC: 'Flash Cards',
  roomD: 'Schulte Table',
  anzan_title: 'Anzan',
  columns_title: 'Columns',
  cards_title: 'Flash Cards',
  schulte_table_title: 'Schulte Table',

  // Math Parameters
  MINIMUM_RATE: 'Minimum answer place value',
  MAXIMUM_RATE: 'Maximum answer place value',
  BOTH_ARE_SMALLER: 'Both smaller',
  BOTH_ARE_BIGGER: 'Both larger',
  OPPOSITE_SIDES: 'Opposite sides',

  // Controls
  START: 'Start',
  STOP: 'Stop',
  MIX: 'MIX',
  CLOSE: 'Close',
  CHECK: 'Check',
  ANSWER: 'Answer',
  ANSWERS: 'Answers',
  PROGRESS: 'Loading',
  ENTER_ANSWER: 'Enter answer',

  // Reports
  REPORT_TITLE:
    'Statistics show completed tasks across all sections: homework and remotely solved problems.',
  REPORT_DESCRIPTION:
    'Correct/incorrect answer counts are shown on the left vertical scale; median values for parameters: interval, number of operands, number place value are marked on the right vertical scale.',
  NUMBER_OF_TERMS: 'Number of operands',
  NUMBER_RANK: 'Number place value',
  digit: 'Digit place value',
  FILTER: 'Filter',

  // Results
  SUCCESS: 'Correct',
  FAIL: 'Incorrect',
  RATE: 'Score',
  ADDRESS: 'Address',
  DESCRIPTION: 'Description',
  FULL_NAME: 'Full name',
  SUCCESS_ALL: 'Correct/Total',
  OPERATION: 'Operations',
  TOTAL_TASKS: 'Total tasks',
  TASKS: 'Tasks',
  TOTAL_SUCCESS: 'Correct answers',

  // Homework
  REPORT_HOMEWORK:
    'Abbreviations: (R) - rule, (S) - section, (F) - formula, (Sg) - sign, (TP) - Time period, (NC) - number of operands, (PV) - place value, (PM) - first multiplier, (SM) - second multiplier',
  ADD_HOMEWORK: 'Create',
  DELETE_HOMEWORK: 'Delete homework',
  DELETE_SELECTED: 'Delete selected',
  SAVE_HOMEWORK: 'Complete and save',
  WARNING_HOMEWORK: 'Changes will affect all students!',
  WARNING_HOMEWORK_DELETE: 'Delete homework assignment?',
  WARNING_HOMEWORK_CHECK: 'Mark homework as checked?',
  WARNING_HOMEWORK_EDIT:
    'Student has already started the assignment. Results will be reset',
  WARNING_HOMEWORK_CANT_EDIT: 'Cannot edit completed assignment!',
  WARNING_HOMEWORK_CANT_DELETE: 'Cannot delete completed assignment!',
  SHOW_SOLUTION: 'Show solution',
  MARK_COMPLETE: 'Grade',
  GO_TO_HOMEWORK: 'Go to assignment',

  // Filter & Pagination
  FILTER_ALL: 'All records',
  FILTER_TITLE: 'Filters',
  FILTER_RESET: 'Reset filters',
  PAGINATION_NEXT: 'Next',
  PAGINATION_PREVIOUS: 'Previous',
  PAGINATION_ROWS_PER_PAGE: 'Rows per page:',
  PAGINATION_DISPLAY_ROWS: 'of',

  VIEW_COLUMN_TITLE: 'Show/hide columns',
  VIEW_COLUMN_TITLE_AREA: 'Show/hide columns',
  VIEW: 'Show',
  HIDE: 'Hide',
  BODY_NO_MATCH: 'No matching records found',
  BODY_NO_TOOL_TIP: 'Sort',
  BODY_NO_COLUMN_HEADER_TOOLTIP: 'Sort by ',
  SELECTED_ROWS_TEXT: 'records selected',
  SELECTED_ROWS_TEXT_HOMEWORKS: 'Checked',
  SELECTED_ROWS_DELETE: 'Delete',
  SELECTED_ROWS_DELETE_ARIA: 'Delete selected records',
  FILTERING: 'Filter',

  // Math Sections
  NEGATIVE_NUMBERS: 'Negative numbers',
  SECTION_UP_TO_FOUR: 'Counting 1-4',
  SECTION_UP_TO_FIVE: 'Counting up to 5',
  SECTION_UP_TO_SIX: 'Counting up to 6',
  SECTION_UP_TO_SEVEN: 'Counting up to 7',
  SECTION_UP_TO_EIGHT: 'Counting up to 8',
  SECTION_UP_TO_NINE: 'Counting up to 9',
  SECTION_MIRROR: 'Mirror numbers',
  SECTION_TEN: 'Round numbers',

  // Division
  DIVISION_TABLE: 'Division table',
  DIVISION_REMAINDER: 'Division with remainder',
  DIVISION_SIMPLE: 'Simple division 4D/2D',
  DIVISION_ONE_ITERATE: 'Division with 1 trial 4D/2D',
  DIVISION_MORE_ITERATE: 'Division with 2+ trials 4D/2D',
  DIVISION_SAME: 'Division with same leading digits 4D/2D',
  DIVISION_BY_ONE: 'Division by 1 4D/2D',
  DIVISION_RANDOM: 'Random division',
  DIVISION_FIRST: 'Dividend',
  DIVISION_SECOND: 'Divisor',

  // Multiplication
  MULTIPLICATION_TABLE: 'Multiplication table',
  MULTIPLICATION_SIMPLE: 'Simple multiplication',
  MULTIPLICATION_RANDOM: 'Random multiplication',
  MULTIPLICATION_ONE_ITERATE: 'Multiplication with 0',
  MULTIPLICATION_MORE_ITERATE: 'Multiplication with 5',
  MULTIPLICATION_FIRST: 'Multiplier 1',
  MULTIPLICATION_SECOND: 'Multiplier 2',
  MULTIPLIER: 'Multiplier',

  // Advanced Math
  DECIMAL_MODE: 'Decimals',
  SQRT: 'Square root',
  CURT: 'Cube root',
  SQUARE: 'Squared number',
  CUBE: 'Cubed number',
  ANSWER_DISCHARGE: 'Answer place value',
  ANSWER_DISCHARGE_TYPE: 'Answer',
  RANDOM_TYPE: 'Random',
  SMALL_FISH: 'Min answer place value (small fish)',
  BIG_FISH: 'Max answer place value (big fish)',
  SMALL_MOUSE: 'Min answer place value (small mouse)',
  BIG_MOUSE: 'Max answer place value (big mouse)',

  // Rotation Types
  ROTATION_TYPE: 'Rotation',
  RANDOM_ROTATION: 'Random',
  SINGLE_ROTATION: 'Single',
  DOUBLE_ROTATION: 'Double',

  // Answers
  NUMERALS: 'Digit(s)',
  RIGHT_ANSWERS: 'Correct answers',
  RIGHT_ANSWER: 'Correct answer ',
  WRONG_ANSWERS: 'Incorrect answers',

  // Simulator Settings
  SIMULATOR_TYPE: 'Trainer type',
  SIMULATOR_SETTINGS: 'Trainer parameters',
  PARAMS: 'Parameters',
  NUMBER_OF_WINDOWS: 'Window count',
  NUMBER_OF_EXAMPLES: 'Sample count',
  count: 'Sample count',
  COMPLETION_TIME: 'Time ',
  TIME_LIMIT_VALUE: 'Time limit (min:sec) ',
  TIME_LIMIT_MODE: 'Time mode',
  LIMITED_TIME: 'Limited time',
  UNLIMITED_TIME: 'Unlimited time',
  RESTART: 'Try again',

  // Division Components
  CEIL: 'Whole',
  REMAINDER: 'Remainder',
  SECOND: 'sec',
  TERMS: 'Operands',

  // Base System
  base: 'Base',
  base_side: 'Base sides',
  digits_mode: 'Digit place value mode',
  DIGITS_MODE_MIN_RANGE: 'Min answer place value',
  DIGITS_MODE_MAX_RANGE: 'Max answer place value',
  DIGITS_MODE_RANDOM_RANGE: 'Random',
  BASE_SIDE_LESS: 'Both below base',
  BASE_SIDE_MORE: 'Both above base',
  BASE_SIDE_DIFF: 'Opposite sides of base',

  // EXCEED
  NOT_EXCEED_50: 'without',
  NOT_EXCEED_100: 'over 50',
  EXCEED_100: 'over 100',

  // Dictation
  DICTATION_AMOUNT: 'Number of samples',
  DICTATION_PERIOD: 'Pause between samples',
  DICTATION_START: 'Start dictation',
  DICTATION_STOP: 'Stop dictation',
  DICTATION_NEXT: 'Continue dictation',

  // School Information
  SCHOOL_NAME: 'Name',
  SCHOOL_CITY: 'City',
  SCHOOL_ADDRESS: 'Address',
  SCHOOL_METRO_STATION: 'Metro station',
  SCHOOL_FULL_NAME_OF_HEAD: "Director's full name",
  PHONE: 'Phone',
  PREVIOUS_PAGE: 'Previous page',
  NEXT_PAGE: 'Next page',
  EDIT_DATA: 'Edit data',
  ADD_RECORD: 'Add record',
  DELETE_RECORD: 'Delete record',
  RESTORE_USER: 'Restore user',
  RECORD_PER_PAGE: 'Rows per page',
  PASSWORD: 'Password',
  DATE_REGISTRATED: 'Registration date',
  DATE_BEGINING: 'Start date',
  DATE_ENDING: 'End date',
  DATE_CREATING: 'Creation date',
  DATE_DELETED: 'Deletion date',
  BY_DAYS: 'By days',
  CREATED: 'Created',

  // UI Elements
  SELECTED: 'Select...',
  NOT_RECORD: 'No records',
  NOT_FOUND_CATEGORIES_FOR_OLIMPIC: 'No categories found for your birth year',
  DIRECTORY_STUDENTS_TITLE:
    'All students who registered on the platform independently, including via referral links',
  ICON: 'Icon',

  // User Interface
  user_guide: 'User guide',
  user_online: 'Online: {count}',
  _users: 'users',
  _online: 'online',
  RESET: 'Reset',
  CHOOSE_THEME: 'Theme selection',
  ABACUS_DESCRIPTION: 'Use the virtual abacus and board to explain new topics.',
  MARKS: 'How to place marks on the abacus',
  ABACUS: 'Abacus',
  DESK: 'Board',

  // Student Management
  GROUPS: 'Group(s)',
  EMAIL_STUDENT: 'Student email',
  NAME_SURNAME_STUDENT: 'Student Name and Surname',
  AGE: 'Age',
  EMAIL_PARENT: 'Parent email',
  NAME_SURNAME_PARENT: 'Parent name',
  ACTIVE: 'Active',
  SEND_EMAIL_TO_STUDENT: 'Send login credentials to this email',
  DATEBIRTH: 'Date of birth',
  YES: 'Yes',
  NO: 'No',
  SEARCH: 'Search',
  SEARCH_STUDENTS: 'Student search',
  SEARCH_DATE: 'Date search',
  REPEAT_PASSWORD: 'Repeat password',
  I_AGREE: 'I agree to the Privacy Policy and Terms of Use',

  // Certification
  WITH_ANSWER: 'Include answers in examples',
  WITH_ANSWER_SEPARATE_SHEET: 'Answers on a separate sheet',
  TO_PRINT: 'Print',
  CERTIFICATION_PAGE_TITLE_SAMA:
    'SAMA GLOBAL ABACUS & MENTAL ARITHMETIC EXAMINATION',
  CERTIFICATION_PAGE_TITLE_PAMA:
    'PAMA GLOBAL ABACUS & MENTAL ARITHMETIC EXAMINATION',
  CERTIFICATION_PAGE_TITLE_UAMAP: 'UAMAP Mental Arithmetic Exam',
  CERTIFICATION_LEVEL_TIME: 'TIME',
  MIN: 'MIN',
  MENTAL_ARITHMETIC: 'Mental calculation',
  ARITHMETIC_FOR_CHILDREN: "Children's levels",
  ARITHMETIC_FOR_TEACHER: 'Teacher levels',
  FOR_CHILDREN: 'For children',
  FOR_TEACHER: 'For teachers',
  ABACUS_ARITHMETIC: 'Abacus calculation',
  MENTAL_ARITHMETIC_ADD: 'MENTAL CALCULATION (+,-)',
  ABACUS_ARITHMETIC_ADD: 'ABACUS CALCULATION (+,-)',
  MENTAL_ARITHMETIC_MULTIPLICATION: 'MENTAL CALCULATION (*)',
  ABACUS_ARITHMETIC_MULTIPLICATION: 'ABACUS CALCULATION (*)',
  MENTAL_ARITHMETIC_DIVISION: 'MENTAL CALCULATION (÷)',
  ABACUS_ARITHMETIC_DIVISION: 'ABACUS CALCULATION (÷)',
  ADD: 'ADDITION',
  CARD: 'NUMBER IMAGE',
  FIVE: 'COMPOSITION OF 5',
  TEN: 'Composition of 10',
  NEXT_LEVEL: 'Next task',
  NEXT_TEST: 'Solve another test',
  RESULT: 'RESULT',
  SCORE: 'Score',
  LEVEL: 'Level',
  LEVEL_1: 'Level 1',
  LEVEL_2: 'Level 2',
  LEVEL_3: 'Level 3',
  LEVEL_4: 'Level 4',
  LEVEL_5: 'Level 5',
  LEVEL_6: 'Level 6',
  LEVEL_7: 'Level 7',
  LEVEL_7_A: 'Level 7 A',
  LEVEL_7_B: 'Level 7 B',
  LEVEL_8: 'Level 8',
  LEVEL_8_A: 'Level 8 A',
  LEVEL_8_B: 'Level 8 B',
  LEVEL_9: 'Level 9',
  LEVEL_9_A: 'Level 9 A',
  LEVEL_9_B: 'Level 9 B',
  LEVEL_10: 'Level 10',
  LEVEL_10_A: 'Level 10 A',
  LEVEL_10_B: 'Level 10 B',
  LEVEL_11: 'Level 11',
  LEVEL_12: 'Level 12',
  LEVEL_13: 'Level 13',
  LINK_BY_VIDEO: 'Disk link',
  SAVE_RESULT_BY_TEST: 'Save exam results',
  STARTING_EXAM: 'BEGIN EXAM',
  ABACUS_TYPE: 'Abacus,',
  MENTAL_TYPE: 'Mental',
  ADD_TYPE: 'Addition and subtraction (+, -)',
  MULTIPLICATION_TYPE: 'Multiplication (*)',
  MULTIPLICATION_TABLE_TYPE: 'Multiplication table (*)',
  MULTIDIVISION_TYPE: 'Multiplication and division table',
  MULTIDIV_TYPE: 'Multiplication and division',
  DIVISION_TABLE_TYPE: 'Division table (÷)',
  DIVISION_TYPE: 'Division (÷)',
  TIE_TYPE: 'Tie-breaker',

  PRINT_CERTIFICATION: 'Print certificate',
  CREATE_CERTIFICATION: 'Create certificate',
  EXAM_CHECKING: 'Exam under review',
  EXAM_STATUS_NOT_FOUND: 'Exam status not determined',
  EXAM_WAITING_RUN: "Exam created and awaiting completion in student's account",
  SET_CODE: 'Enter your code',
  CHECK_CODE: 'Verify',
  CERTIFICATION_NOT_FOUND:
    'Certificate with this code not found, please try again.',

  // Navigation
  SCHEDULE_TITLE: 'Schedule',
  PROFILE_TITLE: 'Profile',
  NEWS_TITLE: 'News',
  NEWS_EDIT_TITLE: 'Feed',
  NEWS_FEED_TITLE: 'Management',
  DELEGATES: 'Representatives',
  TEAM_MODE_TITLE: 'Team mode',
  OLIMPIC_TITLE: 'Competition',
  FOR_PARENTS_TITLE: 'For parents',

  // Actions
  REGISTER: 'Register',

  // Homework Status
  HOMEWORK_STATUS: 'Status',
  COMPLETED: 'Completed',
  OVERCOMPLETE: 'Overcompleted',
  UNCOMPLETED: 'Not completed',

  // General
  USER: 'User',
  CERTIFICAT: 'Certificate',
  CATEGORY: 'Category',
  mark: 'points',

  // General
  COUNTRY: 'Country',
  EXAM_RESULT: 'Exam result',
  GENERATE_XLSX: 'Generate XLSX',
  GENERATE_SAMA_XLSX: 'Generate SAMA XLSX',
  GENERATE_PAMA_XLSX: 'Generate PAMA XLSX',
  SAVE_TO_COMPUTER: 'Save to computer',
  CHANGE_RANKS: 'Modify selected',
  SET_OLIMPIC_RANKS: 'Select rank to assign to participants',

  // Ranking System
  STARS: 'Stars',
  STARS_FOR_HOMEWORK: 'Stars for homework',
  RANK: 'Rank',
  RANK_1: 'Beginner',
  RANK_2: 'Junior',
  RANK_3: 'Bookkeeper',
  RANK_4: 'Expert',
  RANK_5: 'Erudite',
  RANK_6: 'Prodigy',
  RANK_7: 'Know-it-all',
  RANK_8: 'Unique Talent',
  RANK_9: 'Wunderkind',
  RANK_10: 'Genius',
  PLACE_IN_RATING: 'Rating position',
  NO_RATE: 'Not participating',
  FEATHERS: 'Feathers',
  PROGRESS_TO_NEXT_RANK: 'Progress to next rank',

  // Payments & Accounts
  SUMM: 'Amount',
  PURPOSE_OF_PAYMENT: 'Payment purpose',
  ENTER_PASSWORD: 'Enter password',
  CONFIRM_IS_PARENT:
    "To confirm you're the parent, please enter the current account password",
  BALANCE: 'Balance',
  UCOINS1: 'ucoins',
  UCOINS2: 'ucoins',
  UCOINS5: 'ucoins',
  ACCESS_TO_PLATFORM: 'Platform access',
  INFINITY_ACCESS_TO_PLATFORM: 'Unlimited platform access',
  WAIT_PAY:
    'Pending payment. The online checkout page has opened in another browser tab',
  PAY: 'Pay',
  FREE: 'Free',
  CERT_EXAM: 'Certificate exam',
  CERT_EXAMS: 'Certification exam',
  OLIMPIC_PARTICIPATION: 'Competition participation',
  OLIMPIC_PARTICIPATIONS: 'Competition participations',
  CERT_SAMA_GLOBAL_EXAM: 'Purchased SAMA GLOBAL exams',
  CERT_PAMA_GLOBAL_EXAM: 'Purchased PAMA GLOBAL exams',
  CERT_UAMAP_EXAM: 'Purchased UAMAP exams',
  OLIMPIC_ONLINE_PARTICIPATION: 'Online competition participations',
  OLIMPIC_OFFLINE_PARTICIPATION: 'In-person competition participations',
  OLIMPIC_SAMA_PARTICIPATION: 'PAMA competition participations',
  REGISTER_STUDENTS: 'Student access package',
  PURCHASED: 'Purchased',
  DAYS_ON_PLATFORM: 'Days on platform',
  DAYS_LEFT: 'Days remaining',
  SUSPENDED: 'Suspended',
  UNTIL: 'Until',
  PROLONG: 'Extend',
  TOP_UP_ACCOUNT: 'Top up account',
  SAVE_CHANGES: 'Save changes',
  MOBILE_PHONE: 'Mobile phone',

  REFERALS_TITLE: 'Referral system',
  MANAGEMENT: 'Management',
  ABOUT_GAMIFICATION: 'About gamification',
  UCOINS_TITLE: 'Ucoins',
  STATISTICS: 'Statistics',
  THEMATIC: 'Theme',
  CONTENT: 'Content',
  BACK: 'Back',

  // Errors & Messages
  ERROR_INCORRECT: 'The password you entered is incorrect',
  DEADLINE_ERROR: 'Set daily assignment deadline (maximum 1 month)',
  CONFIRM_PAYMENT:
    'Funds will be deducted from your balance for the selected service',
  PAYMENT_LIMIT_WARNING:
    'For international users, only MIR and BELKART cards are accepted',
  PURCHASE_ERROR: 'An error occurred',
  PURCHASE_NOT_ENOUGH: 'Insufficient funds',
  PURCHASE_SUCCESS: 'Purchase completed successfully',
  NOT_ENOUGH_PACK: 'Not enough accesses in package',
  HAVE_ONLINE_OLIMPIC: 'User already has Online Competition access',
  HAVE_OFFLINE_OLIMPIC: 'User already has In-Person Competition access',
  HAVE_MAINTAINERS: 'User already has In-Person Competition companion ticket',
  NOT_REGISTERED_OFFLINE_OLIMPIC:
    "You haven't registered for the In-Person Competition",
  REGISTER_STUDENT_ISUFFICIENT_FUNDS:
    'To register students independently, purchase a suitable access package in the store',
  ACCESS_ISUFFICIENT_FUNDS:
    'Platform access has expired. Renew it in Parents/Management section',
  ACCESS_NO_DEMO_FUNDS:
    'Purchase platform access in Parents/Management section',
  ACCESS_ISUFFICIENT_FUNDS_TEACHER:
    'You need at least 1 student with paid access. You can pay for it yourself',
  ACCESS_NO_DEMO_FUNDS_TEACHER:
    'You need at least 1 student with paid access. You can pay for it yourself',
  SAMA_ACCESS_MESSAGE:
    "Unfortunately, you can't participate in the Competition right now. Please purchase access to the SAMA GLOBAL Competition in the section",
  PAMA_ACCESS_MESSAGE:
    "Unfortunately, you can't participate in the Competition right now. Please purchase access to the PAMA GLOBAL Competition in the section",
  NO_ACCESS: 'This section is unavailable',
  ACCESS_NO_OLIMPIC: 'Competition participation payment required',

  // Products
  PRODUCTS_TITLE: 'Pricing',
  PRODUCTS_LEARNER: 'Student products',
  PRODUCTS_TEACHER: 'Teacher & school products',
  PRODUCTS_SCHOOL: 'School products',
  PRODUCTS_TEACHER_ASSOC: 'Association representative, teacher products',
  PRODUCTS_SCHOOL_ASSOC: 'Association representative, school products',
  PRODUCTS_ASSOC: 'Association representative products',
  CONFIRM_PAY_PRODUCT: 'Confirm purchase of "{product}" for {price} rubles?',
  CONFIRM_PRODUCT: '{price} ucoins will be deducted for {name}.',
  CONFIRM_PRODUCT_SELF: '{price} ucoins will be deducted.',
  CONFIRM_PAYMENT_PACKAGE:
    'Confirm payment from purchased ACCESS PACKAGE for student {name}?',
  CONFIRM_BUY_PACK: 'Confirm purchase of access packages for {name}?',
  CONFIRM_PACK:
    'Access package for {count} students will be purchased for {price} ucoins',
  PACKAGES_AMOUNT: 'Access packages',

  // UI Elements
  OK: 'OK',
  CONFIRM: 'Confirm',
  CONTINUE: 'Continue',
  CANCEL: 'Cancel',
  REFUSE: 'Decline',
  PURCHASES: 'Purchases',
  currency: 'ucoins',
  currency_short: 'u.',
  CURRENCY_EQUAL: '1 ruble = 1 ucoin',
  ENTER_AMOUNT: 'Enter top-up amount',
  NOT_SELECTED: 'Not selected',

  // Mental Arithmetic
  MENTAL_ARITHMETIC_TITLE: 'Mental Arithmetic',
  ROOM_SHORT: 'Rm.',
  TIME: 'time',
  min: 'min.',
  EACH_Q: 'correct answer',
  marks: 'marks',
  DATE: 'Date',
  DATE_FORMAT: 'DD.MM.YYYY',
  SAVE: 'Save',
  SAVE_LINK: 'Save link',
  link: 'Link',
  ADD_LESSON: 'Add lesson',

  // Referral
  RECEIVE_BONUSES: 'Earn bonuses for inviting new students or teachers',
  REFERAL_LINK_FOR_STUDENTS: 'Student referral link',
  REFERAL_LINK_FOR_TEACHERS: 'Teacher referral link',
  COPY: 'Copy',
  ABOUT_REFERAL_ADMIN: 'About referral system',

  // Achievements
  ACHIEVEMENTS: 'Achievements',
  NEW: 'New',
  NEW_OR_COMPLETED: 'New / Completed',
  TODAY_OR_ALL: 'Today / All',
  ALL_ACHIEVEMENTS: 'All achievements',
  HERE_ALL_ACHIEVEMENTS:
    'Here you can view all achievements, both earned and unearned.',
  CLEAR: 'Got it',

  // Assignments
  WORKS: 'Tasks',
  HOME_WORKS: 'Homework',
  ALL_HOME_WORKS: 'All assignments',
  HOME_WORKS_EMPTY: 'No homework',
  ADD_TRAIN: 'Add trainer here',
  COMPLETE: 'Complete',
  COMPLETE_OVER: 'Complete by',

  // Experience System
  FOR_RECEIVE_NEW_ACHIEVEMENTS: 'Gain experience to earn new achievements',
  EXPERIENCE_GRADING: 'Experience grading',
  EXPERIENCE_REQUIRED: 'Required experience',

  // Feathers System
  CONFIRM_RESET_FEATHERS:
    'Are you sure you want to reset feathers for all users?',
  FOR_RESET_FEATHERS: 'Click to reset feathers for all users',
  RESET_FEATHERS: 'Reset feathers',

  CHAMPIONS_CORNER: 'Hall of Champions',
  PHOTO: 'Photo',
  OPEN_ALL_OLIMP_CHAMPIONS: 'Show all competitions',
  // Ratings
  RATING: 'Rating',
  TEACHER_RATING: 'Teacher ranking',
  STUDENT_RATING: 'Student ranking',
  PLACE: 'Place',
  place1: '1st place',
  place2: '2nd place',
  place3: '3rd place',
  PLACE_EN: 'place',
  PLACE_LABEL: 'Rank (number, 0 for champion)',
  OPEN_FULL_LIST: 'View full list',
  USERS_LIST: 'Users list',
  YOUR_PLACE_IN_RATING: 'Your current rank',
  FOR_UP_IN_RATING_TEACHER:
    'To move up: earn achievements, conduct lessons, and invite new students and teachers',
  FOR_UP_IN_RATING_STUDENT:
    'To move up: solve more samples and earn feathers from achievements',

  // User Information
  STUDENT_NAME: 'Student name',
  TEACHER_NAME: 'Teacher name',
  POINTS: 'Points',
  TEACHER_ADD_STUDENT:
    'added your child to their student list. Confirm action?',

  // Subscriptions
  SUBSCRIBE_1_MONTH: '1-month subscription',
  FROM_PACKET: 'from package',
  SUBSCRIBE_1_MONTH_PACKET: '1-month subscription from package',
  SUBSCRIBE_6_MONTH: '6-month subscription',
  SUBSCRIBE_12_MONTH: '1-year subscription',

  // Certifications
  SAMA_CERT: 'SAMA GLOBAL Certification',
  PAMA_CERT: 'PAMA GLOBAL Certification',
  UAMAP_CERT: 'UAMAP Student Certification',
  UAMAP_CERT_TEACHER: 'UAMAP Teacher Certification',
  SAMA_CERT_SHORT: 'SAMA GLOBAL',
  PAMA_CERT_SHORT: 'PAMA GLOBAL',
  UAMAP_CERT_SHORT: 'UAMAP Student',
  UAMAP_CERT_TEACHER_SHORT: 'UAMAP Teacher',

  // Time Periods
  MONTH: 'month',
  MONTHS: 'months',
  STUDENT_GENITIVE: "student's",
  STUDENTS_GENITIVE: "students'",

  // Selection
  SELECT: 'Select',
  SELECT_PRODUCT: 'Select product',
  SELECT_USER: 'Select user',
  SELECT_LEARNER: 'Select student',
  SELECT_STUDENT: 'Select student',
  SELECT_TEACHER: 'Select teacher',
  SELECT_STUDENTS_AMOUNT: 'Select number of participants',

  // Ucoins & Transactions
  ACCESS: 'Platform access purchase for',
  REPLENISHMENT: 'Top-up',
  PACKET: 'Access package purchase for',
  ACCESS_FROM_PACKET: 'Platform access purchase from package',
  SAMA_PAYMENT: 'SAMA GLOBAL certification exam purchase',
  PAMA_PAYMENT: 'PAMA GLOBAL certification exam purchase',
  UAMAP_PAYMENT: 'UAMAP certification exam purchase',
  ONLINE_OLIMPIC_PAYMENT: 'Online competition participation purchase',
  OFFLINE_OLIMPIC_PAYMENT: 'In-person competition participation purchase',
  SAMA_OLIMPIC_PAYMENT: 'SAMA GLOBAL competition participation purchase',
  PAMA_OLIMPIC_PAYMENT: 'PAMA GLOBAL competition participation purchase',
  MAINTAINER_PAYMENT: 'Competition companion',

  // Gamification Explanations
  GAMIFICATION_1:
    "Gamification is the application of game mechanics in non-game contexts. This gamification system aims to increase user engagement and interest. The ranking is based on the teacher's and their students' achievements. Exams, referred students, and lesson count improve your ranking.",
  GAMIFICATION_2:
    'Teachers can earn achievements by completing specific platform tasks.',
  GAMIFICATION_3:
    'Gamification is about games. Here you can play and develop. This tab explains all game mechanics on the platform. Feathers are points that form student rankings. The ranking is a list of all students based on their achievements. Titles are levels you progress through by earning achievements. Achievements are rewards for completing specific actions.',
  GAMIFICATION_4: "Now let's go into more detail",
  GAMIFICATION_5:
    'The ranking updates every 3 months, allowing top students and teachers to win valuable prizes.',
  GAMIFICATION_6:
    'Rankings are based on feathers earned (students) and rating points (teachers). More points = higher rank. Top-ranked users receive physical and virtual prizes.',
  GAMIFICATION_7: 'Achievements contribute to teacher rankings.',
  GAMIFICATION_8:
    'To maximize achievements and rating points: take exams, conduct lessons, and engage with the platform.',
  GAMIFICATION_9:
    'Also motivate your students to fully immerse in mental math.',
  GAMIFICATION_10: "Remember this, and you'll reach the top of the rankings!",
  GAMIFICATION_11:
    'Achievements are fun badges earned through platform activities. Each gives experience points and feathers.',
  GAMIFICATION_12:
    'Achievements become colored when earned (currently grayscale). You can preview potential rewards.',
  GAMIFICATION_13:
    'Rating points are earned through key platform actions and achievements.',
  GAMIFICATION_14:
    'Actions include teaching lessons, assigning homework, and user referrals.',
  GAMIFICATION_15:
    'Feathers are student ranking points earned through achievements and problem-solving (harder problems = more feathers). Reset every 3 months to determine new winners.',
  GAMIFICATION_16:
    'Titles represent your progress through completed tasks and achievements. More experience = better titles.',
  GAMIFICATION_17:
    "Each level grants a new title and unique profile avatar frame. 'Genius' (Level 10) is the highest.",
  GAMIFICATION_18:
    "Rumor says not everyone reaches it... If you do, consider the platform 'completed' like a game.",
  GAMIFICATION_19: 'Stars are teacher evaluations of completed homework.',
  GAMIFICATION_20:
    "Better effort = more stars. Be your teacher's best student!",

  // Referral System
  REFERAL_ADMIN: 'Referral System',
  MOVE_UCOINS_TO_BALANCE: 'Transfer ucoins to balance',
  INVITED_STUDENTS: 'Referred students',
  ACTIVE_STUDENTS: 'Active students with platform access',
  INVITED_TEACHERS: 'Referred teachers',
  EARNED_UCOINS: 'Ucoins earned',
  REFERAL_TEXT_1: 'The referral system lets you earn ucoins for free.',
  REFERAL_TEXT_2:
    'Have new students register and pay for subscriptions via your link.',
  REFERAL_TEXT_3: "You'll receive 25 ucoins per student.",
  REFERAL_TEXT_4:
    'Earn free ucoins by referring students and teachers via your link.',
  REFERAL_TEXT_4_S:
    "Earn free ucoins when students/teachers register via your or your teachers' links.",
  REFERAL_TEXT_5:
    'Get 25 ucoins when referred students first pay for platform access.',
  REFERAL_TEXT_5_S:
    'Get 25 ucoins when students referred by you/your teachers first pay.',
  REFERAL_TEXT_6:
    'Get 50 ucoins when teachers you referred have students who pay.',
  REFERAL_TEXT_6_S:
    'Get 50 ucoins when teachers referred by you/your teachers have paying students.',
  REFERAL_TEXT_7: "Earn 5% of referred students' top-up amounts.",
  REFERAL_TEXT_7_S:
    'Earn 2% of top-ups from students referred by you/your teachers.',

  // Olympiad
  PERSONAL_RATING: 'Personal ranking',
  PUBLIC_RATING: 'Overall ranking',
  RATING_UPDATE: 'Ranking updates daily at 00:00 (Moscow time)',
  SCORES_TITLE: 'Rating points',
  RESULTS: 'Results',
  RESULTS_NOTICE:
    'Rank may drop due to missing video or past winners competing in same category without advancement',
  PARTICIPATE: 'Participate',
  PARTICIPATE_OFFLINE: 'Participate in In-Person Competition',
  OFFLINE_OLIMPIC_PARTICIPATE_NOTICE:
    'Now, fill in all the fields and click "Participate" to register for the Competition',
  OLIMPIC_REGLAMENT_NOTICE:
    'Please carefully review the regulations of the Competition!',
  GET_READY: 'Get ready!',
  CURRENT_PING: 'Current connection quality',
  SEC: 'sec.',
  GOOD: 'Good',
  NORMAL: 'Normal',
  WORST: 'Poor',
  DISCONNECTED: 'Disconnected',
  OLIMPIC_TYPE: 'Competition type',
  olimpic_files: 'Upload files and insert required links',
  OLIMPIC_LINK_REQUIRED_NOTIFY:
    ' The video link is required, otherwise the prize place will be lowered! Make sure that access to the video is open. You can also attach a link after the Competition before checking the results',
  OLIMPIC_START_NOTIFY:
    ' We wish you good luck and victory! After clicking the “Start Competition” button, you will not be able to go back, you will only have 1 attempt. The entire Competition must be filmed from beginning to end. Upload the video to any cloud storage and attach a link.',
  OLIMPIC_PRE_RUN_NOTIFY:
    'Confirm your readiness and wait for the end of the preparation timer',
  IVE_READ_RULES: 'I have read carefully and agree with the above rules',
  PREPARED_CAMERA:
    'I am ready to film the process of passing the Competition on a video camera, and I agree to provide a video for verification',
  OLIMPIC_TECHNICAL_REQUIREMENT:
    'Check the quality of the Internet connection. Tab navigation, page restarts and refreshes are PROHIBITED, and your participation will be completed!',
  IM_READY:
    "I am ready to start the Competition. I have no connection problems and I'm not going to leave the page until the result of the Competition is saved.",

  ABOUT_OLIMPIC: 'Competition',
  SAMA_OLIMPIC: 'Sama Global',
  PAMA_OLIMPIC: 'Pama Global',
  PAY_OFFLINE_SELF: 'Buy ticket for yourself',
  PAY_OTHER_OFFLINE: 'Buy ticket for others',
  OFFLINE_OLIMPIC: 'In-person',
  OFFLINE_OLIMPIC_FOR_STUDENT: 'In-person for Student',
  OFFLINE_OLIMPIC_FOR_TEACHER: 'In-person for Teacher',
  ONLINE: 'Online',
  ONLINE_LEARNER: 'Online for Student',
  ONLINE_TEACHER: 'Online for Teacher',
  OLIMPIC_REQUIRE_PAYMENT: 'Competition participation payment required',
  ACCESS_REQUIRE_PAYMENT: 'Platform access payment required',
  REQUIRE_FIELDS: 'All fields must be filled',
  OLIMPIC_LIST: 'Competition list',
  OLIMPIC_NOT_FOUND: 'No upcoming competitions found',
  WILL_PASS: 'will take place',
  CREATE: 'Add',
  OLIMPIC_TABLE_CREATE_TITLE: 'Create competition',
  OLIMPIC_TABLE_EDIT_TITLE: 'Edit competition',
  OLIMPIC_TABLE_EDIT_PARTICIPANT: 'Edit competition participant',
  OLIMPIC_SUCCESS_CREATE_MESSAGE: 'Competition created successfully',
  OLIMPIC_SUCCESS_EDIT_MESSAGE: 'Competition updated successfully',
  OLIMPIC_PRINT_TITLE: 'Print tasks',
  TIME_BEGINING: 'Start time',
  TIME_ENDING: 'End time',
  OLIMPIC_SIMULATOR: 'Competition simulator',
  OLIMPIC_REGLAMENT: 'Regulations',
  OLIMPIC_GROUPS_TASKS: 'Group tasks',
  OLIMPIC_START_VIDEO_LINK: 'Pre-competition video link',
  OLIMPIC_END_VIDEO_LINK: 'Post-competition video link',
  OLIMPIC_DIPLOMA_LINK_RU: 'Diploma template link (Russian)',
  OLIMPIC_DIPLOMA_LINK_EN: 'Diploma template link (English)',
  OLIMPIC_GRATITUDE_LINK_RU: 'Certificate of appreciation template (Russian)',
  OLIMPIC_GRATITUDE_LINK_EN: 'Certificate of appreciation template (English)',
  CUP_IMAGE_LINK: 'Cup Image URL (Champions Corner)',
  OLIMPIC_SYLLABUS: 'Syllabus',
  OLIMPIC_RUN: 'Start competition',
  SHOW_OFFLINE: 'Show for In-person',
  SHOW_ONLINE: 'Show for Online',
  SHOW_SAMA: 'Show for PAMA',
  RESET_OLIMPIC_PAYMENTS: 'Reset competition payments',
  RESET_FOR_ONLINE: 'Reset for ONLINE',
  RESET_FOR_OFFLINE: 'Reset for IN-PERSON',
  RESET_FOR_SAMA: 'Reset for PAMA',
  CONFIRM_RESET_ALL_OLIMPIC_PAYMENTS: 'Confirm reset all competition payments?',
  OLIMPIC_PAY_PARTICIPATE: 'Pay for competition participation',
  OLIMPIC_PAY: 'Pay participation',
  OFFLINE_OLIMPIC_PAY_PARTICIPATE: 'Pay for in-person competition',
  SAMA_OLIMPIC_PAY_PARTICIPATE: 'Pay for SAMA competition',
  PAMA_OLIMPIC_PAY_PARTICIPATE: 'Pay for PAMA competition',
  OLIMPIC_REGISTERED: 'You’ve registered for the competition',
  OLIMPIC_STARTS: 'It will take place',
  FROM: 'from',
  TO: 'to',
  OLIMPIC_COMPLETED: 'Competition already completed',
  DIPLOMS: 'Diplomas',
  DIPLOMA: 'Diploma',
  DIPLOM_FOR_CENTER: 'Center diploma',
  DIPLOM_FOR_TEACHER: 'Teacher diploma',
  CHANGE_TEXT: 'Edit text',
  ENTER_TEXT: 'Enter text',
  YEARS: 'years',
  PAYMENT_PARAM_VALIDATION: 'Product selection required',
  PAYMENT_PARAMS_VALIDATION: 'Product and student selection required',
  EXAM_REQUIRE_PAYMENT: 'Exam payment required',
  OVERALL_SCORE: 'Total score',
  SCORE_O: 'Score',
  SCORE_MAX: 'Max score',
  STAGE: 'Stage',
  stage_num: 'Stage {stage}',
  OLIMPIC_PRINT_CLOSED_FOR_TEACHER:
    'Minimum one paid student required to print competition tasks',
  OLIMPIC_PRINT_CLOSED_FOR_STUDENT:
    'Platform access payment required to print competition tasks',
  PARTICIPANTS: 'Participants',
  OFFLINE_OLIMPIC_PARTICIPANTS: 'In-person Competition Participants',
  PARTICIPANT_OVZ: 'Participant with disabilities',
  REQUIRED_OVZ_DOCUMENT:
    'Please submit a disability certificate (matching Association rules) via Telegram',
  OVZ: 'Disabilities',
  ASSOCIATION: 'Association',
  export: 'Export',
  MAINTAINER: 'Companion',
  TSHORT: 'T-shirt',
  TSHIRT_SIZE: 'T-shirt size',
  MAINTAINERS_COUNT: 'Number of companions',
  MAINTAINERS_LIMIT_FOR_1_PARTICIPANT:
    'Companion tickets per participant limit',
  OLIMPIC_PARTICIPANT_SUCCESS_EDIT_MESSAGE: 'Competition participant updated',
  OLIMPIC_PARTICIPANTS_SUCCESS_EDIT_MESSAGE: 'Competition participants updated',

  PARTICIPANT_NOT_FOUND: 'Participant not found',
  PAID: 'Paid',
  PAID_6_MONTHS: 'Require 6-month payment',
  REQUIRED_6_MONTHS_OLIMPIC:
    'Competition is only available to active users. You must have had platform access paid for the last 6 months. You can purchase access for the next 6 months now. Please review the competition rules.',
  PAID_9_MONTHS: 'Require 9-month payment',
  REQUIRED_9_MONTHS_OLIMPIC:
    'Competition is only available to active users. You must have had platform access paid for the last 9 months. You can purchase access for the next period «1-year subscription» now. Please review the competition rules.',
  CONFIRM_DELETE_USER:
    'WARNING! Are you sure you want to delete this user? THIS CANNOT BE UNDONE!',
  CONFIRM_DELETE_USERS:
    'WARNING! Are you sure you want to delete {count} users? THIS CANNOT BE UNDONE!',
  CONFIRM_ALIVE_USER: 'Are you sure you want to restore this user?',
  DELETED_USERS_TITLE: 'Deleted users',
  CONFIRM_DELETE_OLIMPIC: 'Are you sure you want to delete this competition?',
  CONFIRM_CLEAR_RESULT:
    "Are you sure you want to reset the participant's results?",
  CONFIRM_DELETE_OFFLINE_PARTICIPANT:
    "Are you sure you want to delete the participant's ticket and their companions?",
  CONFIRM_DELETE_ONLINE_PARTICIPANT:
    'Are you sure you want to delete the participant?',
  OLIMPIC_ENCOURAGE:
    'We wish you good luck and victory! After clicking the “START OLIMPIC” button, you will not be able to go back, you will only have 1 attempt. The entire Competition from beginning to end must be filmed. Upload the video to any cloud storage and attach a link.',
  OLIMPIC_LINK_WARN:
    'A video link is required, otherwise the prize place will be lowered! Make sure that access to the video is open. Attach the link is also available after the Competition before checking the results',
  LINK_NOTICE:
    'The link can be attached later on the Competition tab. Please note Without video, the result will not be counted.',
  OLIMPIC_CONGRATS: 'Congratulations, your attempt is complete',

  END: 'Finish',
  BOLD: 'Bold',
  custom_text: 'Text',
  CHAMPION: 'Champion',
  CHAMPION_EN: 'Champion',
  COMPETITOR_EN: 'Competitor',
  COMPETITOR: 'Competitor',
  // Math Categories
  AddMENTAL: 'Mental Addition/Subtraction',
  AddABACUS: 'Abacus Addition/Subtraction',
  Card: 'Number Visualization',
  MultiABACUS: 'Abacus Multiplication',
  DivisionABACUS: 'Abacus Division',
  Multi: 'Multiplication Table',
  Division: 'Division Table',
  MultiMENTAL: 'Mental Multiplication',
  DivisionMENTAL: 'Mental Division',
  MultiDivision: 'Multiplication/Division Table',

  AddMENTALen: 'Mental addition and subtraction',
  AddABACUSen: 'Addition and subtraction on the Abacus',
  Carden: 'Flash cards',
  MultiABACUSen: 'Multiplication on the Abacus',
  DivisionABACUSen: 'Division on the Abacus',
  Multien: 'Multiplication table',
  Divisionen: 'Division table',
  MultiMENTALen: 'Mental multiplication',
  DivisionMENTALen: 'Mental division',
  MultiDivisionen: 'Multiplication and division table',

  // Competition Management
  OPEN_TICKET_SALES: 'Open ticket sales',
  SHOW_RESULTS: 'Show results',
  SHOW_DIPLOMS: 'Show diplomas',
  ACTIVE_SIMULATION: 'Enable simulation',
  SHOW_RATING: 'Show ranking',
  SHOW_PRINT: 'Enable task printing',
  ACTIONS: 'Actions',
  ACTION: 'Action',
  DIPLOM_EN: 'Diploma (English)',
  DIPLOM_RU: 'Diploma (Russian)',
  AFTER: 'after',
  DICTANT_SETTINGS: 'Dictation settings',
  OLIMPIC_SUCCESS_RESULT: 'Competition results saved successfully',
  PHONE_INVALID: 'Invalid or missing phone number.',

  // Exam Statuses
  EXAM_NEW: 'Exam created',
  EXAM_FINISHED: 'Exam completed',
  EXAM_IN_PROCESS: 'Exam in progress',
  EXAM_ARCHIVE: 'Exam archived',
  EXAM_SUCCESSFUL: 'Exam passed successfully',
  EXAM_SUCCESSFUL_RUN: 'You passed the exam, await your certificate',
  EXAM_FAILURE: 'Exam failed',
  EXAM_FAILURE_RUN: "You didn't pass the exam, keep practicing",
  EXAM_NOT_REQUIRED_NUMBER_OF_POINTS:
    "User didn't reach required points (>=70 per task)",
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_SAMA:
    'Teachers cannot issue SAMA certificates - admin only',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_PAMA:
    'Teachers cannot issue PAMA certificates - admin only',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION:
    'Teachers cannot issue certificates - admin only',

  // Homework Statuses
  new: 'New',
  process: 'In progress',
  success: 'Completed',
  overfill: 'Overachieved',
  left_tasks: 'Remaining',

  // Motivational Phrases
  HIT_1: 'Impress your teacher!',
  HIT_2: 'Amaze everyone!',
  HIT_3: 'Take it to the next level!',
  HIT_4: 'Can you do even better?',

  // Training Modes
  FLASH_CARD: 'Flash Cards',
  FLASH_BATTLE: 'Flash-Battle',
  ANZAN: 'Anzan',
  ANZAN_VIRTUAL: 'Virtual Anzan',
  SOUND: 'Sound',
  AUTOREPEAT: 'Auto-repeat',
  DICTANT: 'Dictation',
  SHOW_ANSWERS: 'Dictation Answers',
  SHOW_EXAMPLES: 'Show sample(s)',
  HIDE_EXAMPLES: 'Hide sample(s)',
  SHOW_ANSWER: 'Show Answers',
  HIDE_ANSWER: 'Hide Answers',
  EXAMPLE: 'Sample',
  max_discharge: 'Maximum answer place value (big fish)',
  min_discharge: 'Minimum answer place value (small fish)',
  ABACUS_FULL: 'Show full abacus',
  ABACUS_ALIGN: 'Calculate from abacus center',

  // Modals
  UPDATE_MODAL_TITLE: 'Dear User!',
  UPDATE_MODAL_MESSAGE:
    "We've updated our platform! Fixed issues and added new features. Refresh the page to start using them!",
  UPDATE: 'Update',
  SKIP: 'Later',

  // Progress Messages
  EXAMPLE_EXECUTED_CONGRATS: 'Congratulations, this task is complete!',
  TIME_OVERWRITE_WARNING:
    'Please note: In the Schulte trainer, each new result overwrites the previous one, even if the completion time has increased.',
  GO_NEXT_EXAMPLES: 'Go to other tasks',
  GO_LINK: 'Go',
  CONTINUE_EXAMPLE: 'Continue this task',

  // Teamwork
  TEAMWORK_USERS_INVITE_TITLE: 'Invite students who are currently online!',
  TEAMWORK_INVITE_TITLE: '{user} invites you to a session!',
  INVITE_ACTION: 'Invite',
  INVITED: 'Invited',
  ACCEPT: 'Accept',
  DECLINE: 'Decline',
  TEAMWORK_KICK_TITLE:
    'Are you sure you want to remove {user} from the session?',
  'teamwork.user.joined': 'Student joined',
  'teamwork.user.left': 'Student left the trainer',

  // Painter
  CLEAR_DRAWING: 'Clear',
  SIZE: 'Size',
  COLOR: 'Color',
  PIXELS_SHORT: 'px',

  // Referral Clues
  S_REFERRAL_CLUE:
    "Share your link! When friends register and pay for access, you'll get 25 ucoins",
  T_TO_S_REFERRAL_CLUE_1:
    "Share with your students and others! When they register and pay, you'll get 25 ucoins!",
  T_TO_S_REFERRAL_CLUE_2: 'Note: ',
  T_TO_S_REFERRAL_CLUE_3:
    'you still need to connect your students via Directories/Students/Add from list',
  T_TO_T_REFERRAL_CLUE:
    "Refer other teachers! When they register and connect students who pay, you'll get 50 ucoins!",

  // System Clues
  RATING_CLUE: 'Ranking updates daily at 00:00 (Moscow time)',
  S_ACCESS_CLUE: 'Full platform access begins immediately after payment',
  S_CERT_EXAM_CLUE:
    'After certificate payment, notify your teacher/admin to schedule the exam',
  OLIMPIC_PARTICIPATION_CLUE:
    'Competitions require separate payment. Simulations and online participation only available with active platform access',

  // Balance Clues
  BALANCE_CLUE_1: 'All prices in ucoins (1 ucoin = 1 ruble). ',
  BALANCE_CLUE_2: "To purchase, top up your balance via 'Top Up Account'. ",
  BALANCE_CLUE_3:
    "Don't forget to complete purchases to activate paid features!",

  // Teacher Access Clues
  T_ACCESS_CLUE_1: 'Purchase student access here. ',
  T_ACCESS_CLUE_2:
    'Paid features unlock immediately for the purchased duration. ',
  T_ACCESS_CLUE_3: 'To pay from ',
  T_ACCESS_CLUE_4: 'pre-purchased access packages ',
  T_ACCESS_CLUE_5: "select only '1 month from package'!",

  // Certification Clues
  T_CERT_EXAM_CLUE:
    "After student payment, create their exam under 'Certification/Exam' or contact admin. Teachers can only take UAMAP exam after training",
  CERT_EXAM_CLUE_2: "'Exam' tab requires active platform access",

  // Package Clues
  ACCESS_PACKET_CLUE_1:
    'Discounted monthly student access (per student rate). ',
  ACCESS_PACKET_CLUE_2:
    'Packages have unlimited storage and stack. Extend student access anytime. ',
  ACCESS_PACKET_CLUE_3:
    "Check remaining balance under Platform Access '1 month from package (Remaining: ...)'",

  // Homework Clues
  NEW_HOMEWORK_CLUE_1:
    'Only current active homework settings shown here. Expired assignments disappear automatically. ',
  NEW_HOMEWORK_CLUE_2: 'Edit tasks to avoid over-assigning. ',
  NEW_HOMEWORK_CLUE_3: "Completed HW appears under 'For Review'",
  CREATE_HOMEWORK_CLUE:
    'Note: HW is marked complete ONLY when ALL trainers reach the required example count. ',
  DAILY_HOMEWORK_CLUE:
    "'Daily' setting creates fresh HW each day. Incomplete daily work (without 'Completed' status) isn't saved. We promote positive motivation - no debt tracking. ",
  DAILY_MAX_HOMEWORK_CLUE:
    'Current limit: {count} daily assignments. More students = higher limit',
  DEADLINE_HOMEWORK_CLUE:
    "For long-term completion goals, use the 'Complete by' setting",

  // Homework Completion
  COMPLETED_HOMEWORK_CLUE_1:
    "Homework is marked complete with 'Done' or 'Overachieved' status.",
  COMPLETED_HOMEWORK_CLUE_2:
    'Appears here the day after completion. Students can exceed requirements within 24 hours. Note the done/overachieved counters when reviewing.',
  COMPLETED_HOMEWORK_CLUE_3: 'Rate Homework using stars and comments',

  // Exam Requirements
  EXAM_CLUE:
    'Exam attempt must be recorded (video required). Attach link to recording.',
  EXAM_CLUE_2:
    'Upload video to cloud storage (Google Drive, Yandex Disk, etc.) and share link.',

  // Abacus Interaction
  ABACUS_CLUE: 'Click abacus beam to mark. Click again to remove mark.',

  // Competition Management
  CREATE_PARTICIPANT: 'Create new participant',
  EDIT_PARTICIPANT: 'Edit participant',
  SELECT_COUNTRY: 'Select country',
  SELECT_CATEGORY: 'Select category',
  OLIMPIC_CHOOSE_CATEGORY:
    'Choose a category strictly higher if you have previously won a prize. There may be disqualifications if rules are not followed',
  DELEGATE: 'Representative',
  CREATE_DELEGATE: 'Create new representative',
  EDIT_DELEGATE: 'Edit representative',
  SET_PLACE: 'Assign placement',
  CLEAR_RESULT: 'Clear results',

  // Information Sections
  REGULATIONS: 'Regulations',
  INFORMATION: 'Information',
  DIPLOMAS: 'Diplomas',
  MENTAL: 'Mental',
  SELECT_PLACE: 'Select place',

  // Technical
  SOUND_CLUE: 'Speech synthesis not supported in your browser',

  // Data Table
  'table.no-match': 'Sorry, no matching records found',
  'table.tooltip': 'Sort',
  'table.next': 'Next page',
  'table.previous': 'Previous page',
  'table.rows_per_page': 'Rows per page:',
  'table.display_rows': 'of',
  'table.jump_to_page': 'Go to page:',
  'table.search': 'Search',
  'table.download_csv': 'Download',
  'table.print': 'Print',
  'table.view_columns': 'View columns',
  'table.filter_table': 'Filters',
  'table.all': 'All',
  'table.filter_title': 'Filters',
  'table.reset': 'Reset',
  'table.title': 'Visible columns',
  'table.title_aria': 'Show/Hide columns',
  'table.text': 'selected',
  'table.delete': 'Delete',
  'table.delete_aria': 'Delete selected rows',

  // Products
  'product.type_1.1': 'Platform access (1 month)',
  'product.type_1.6': 'Platform access (6 months)',
  'product.type_1.12': 'Platform access (12 months)',
  'product.type_2.10': 'Access package (10 students)',
  'product.type_2.25': 'Access package (25 students)',
  'product.type_2.50': 'Access package (50 students)',
  'product.type_3.1': 'Access from package',
  'product.type_4.0': 'PAMA exam access',
  'product.type_5.0': 'UAMAP exam access',
  'product.type_6.0': 'Online competition access',
  'product.type_7.0': 'In-person competition access',
  'product.type_8.0': 'Companion ticket',
  'product.type_9.0': 'PAMA competition access',
  'product.type_10.0': 'PAMA Global in-person competition access',
  'product.type_11.0': 'Companion ticket',

  // Exams
  ONLY_MENTAL: 'MENTAL only',

  // Teacher Level Exams
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_1: '10 samples: 3-4D10R abacus',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_2: '20 samples: 3D*3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_3: '20 samples: 4-5D/2-3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_4: '10 samples: 2D6R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_5: '20 samples: 2D*1D, 3D/1D',

  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_1: '10 samples: 2-3D10R abacus',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_2: '20 samples: 2D*2D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_3: '20 samples: 3-4D/1D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_4: '10 samples: 1D7R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_5: '10 samples: 1-2D5R',

  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_1:
    '50 samples: multiplication table',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_2: '50 samples: division table',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_3: '20 samples: 1-2D10R abacus',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_4: '20 samples: 1D6R',

  // Student Level Exams (6-13)
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_1: '10 samples: 3-4D10R abacus',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_2: '20 samples: 3D*2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_6_SECTION_3: '20 samples: 3-4D/2-3D',
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_4: '10 samples: 2D4R',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_5: '20 samples: 2-3D*1D',

  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_1: '10 samples: 2-3D10R abacus',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_7_SECTION_2: '20 samples: 2D*2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_7_SECTION_3: '20 samples: 3-4D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_4: '10 samples: 1D7R',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_5: '10 samples: 1-2D5R',

  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_1: '10 samples: 2D10R abacus',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_8_SECTION_2: '20 samples: 3D*1D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_8_SECTION_3: '20 samples: 2-3D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_4: '10 samples: 1D6R',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_5: '10 samples: 1-2D4R',

  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_1: '20 samples: multiplication table',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_2: '10 samples: 1-2D10R abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_3: '10 samples: 2D4R abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_4: '10 samples: 1D4R',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_5: '10 samples: 1D5R',

  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_1: '20 samples: number bonds of 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_2: '10 samples: 1D10R abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_3: '10 samples: 2D4RF5 abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_4: '10 samples: 1D5RF5',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_5: '10 samples: 1D4RF10',

  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_1: '20 samples: number bonds of 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_2: '10 samples: 1D8RF10 abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_3: '10 samples: 2D3RF5 abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_4: '10 samples: 1D5RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_5: '10 samples: 1D3RF5',

  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_1: '20 samples: number bonds of 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_2: '10 samples: 1D6RF5 abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_3: '10 samples: 2D3RNF abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_4: '10 samples: 1D4RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_5: '20 samples: 2D flash cards',

  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_1: '20 samples: number bonds of 5',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_2: '10 samples: 1D5RNF abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_3:
    '10 mirrored samples: 2D3RNF abacus',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_4: '10 samples: 1D3RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_5: '20 samples: 1D flash cards',

  // UI/Management
  VISIBILITY: 'Visibility',
  HISTORY_TITLE: 'Transaction History',
  OLIMP_PURCHASES: 'Competition Purchases',
  CREATOR: 'Creator',

  // News
  files: 'Files',
  fullscreen: 'Fullscreen',
  DROP_FILES: 'Click, drag or paste files to upload...',
  NEWS_TYPE: 'News category',
  DEFAULT_NEWS: 'Regular',
  UPDATE_NEWS: 'Update',
  FEATHERS_NEWS: 'Feathers',
  WHITE_NEWS: 'White',
  BLUE_NEWS: 'Blue',
  RED_NEWS: 'Red',
  YELLOW_NEWS: 'Yellow',
  GREEN_NEWS: 'Green',
  PURPLE_NEWS: 'Purple',

  NEWS_UNCHECKED: "What's new?",
  NEWS_CHECKED: 'Already seen',
  NEWS_CHECKED_ALL: "You're up to date! Keep it up!",
  NEWS_HEADER: 'Hot news!',
  NEWS_EMPTY: 'No news yet. Stay tuned!',
  FIRST_PAYMENT: 'First payment',
  INVITED_STUDENTS_2: 'Referred students',
  INVITED_TEACHERS_2: 'Referred teachers',

  // Groups/Auth
  GROUP_MEMBERS: 'Group members',
  RESTORE_PASSWORD: 'Reset password',
  DUPLICATES_TITLE: 'Is this your account?',
  DIRECTORY_DUPLICATES_TITLE: 'Possible duplicates',
  REGISTER_NEW: 'Register new',

  /// /////////////////////////////

  DELETE_CONFIRM: 'Confirm deletion',

  // Added later
  // start Nav
  'nav.burger': 'Menu',
  'nav.ru': 'Russian',
  'nav.en': 'English',
  'nav.signin': 'Login',
  'nav.signup': 'Sign Up',
  'nav.forgot_password': 'Forgot password?',
  'nav.create': 'Create Account',
  'nav.im_teacher': "I'm a Teacher",
  'nav.im_student': "I'm a Student",
  'nav.register_modal_title': 'Who are you registering as?',
  // end Nav

  // start Sidebar
  'sidebar.settings': 'Settings',
  'sidebar.change_password': 'Change Password',
  'sidebar.logout': 'Log Out',
  'sidebar.homeworks.await': 'Pending Assignments',
  'sidebar.homeworks.check': 'To review',
  'sidebar.homeworks.history': 'Assignment History',
  // end Sidebar

  // end table

  // register forms

  REGISTER_AS: 'How would you like to register on the platform?',
  REGISTER_AS_PARENT: "As a student's parent",
  REGISTER_AS_TEACHER: 'As a teacher',

  // ACHIEVEMENTS
  // ACHIEVEMENTS
  // student
  'achievement.student.first_homework.title': 'Off to a Great Start',
  'achievement.student.first_homework.desc':
    'You completed your first homework — keep it up!',

  'achievement.student.2_homeworks_per_day.title': 'Double the Fun!',
  'achievement.student.2_homeworks_per_day.desc':
    'That’s already your second homework today — unstoppable!',

  'achievement.student.homeworks_for_week_comleted.title': 'Smooth Sailing!',
  'achievement.student.homeworks_for_week_comleted.desc':
    'Great job! You’ve been completing all your homework for a whole week!',

  'achievement.student.homeworks_for_month_comleted.title':
    'Mission Accomplished',
  'achievement.student.homeworks_for_month_comleted.desc':
    'We’re impressed by your dedication! You’ve completed all your homework for a full month!',

  'achievement.student.10_homeworks_completed.title': 'Small but Mighty!',
  'achievement.student.10_homeworks_completed.desc':
    'Awesome! You’ve completed 10 homework assignments on the platform.',

  'achievement.student.50_homeworks_completed.title': 'Results Are Showing!',
  'achievement.student.50_homeworks_completed.desc':
    'Awesome! You’ve completed 50 homework assignments on the platform.',

  'achievement.student.100_homeworks_completed.title': 'Nothing Can Stop Me!',
  'achievement.student.100_homeworks_completed.desc':
    'Awesome! You’ve completed 100 homework assignments on the platform.',

  'achievement.student.500_homeworks_completed.title':
    'Infinity Is Not Enough!',
  'achievement.student.500_homeworks_completed.desc':
    'Incredible! You’ve completed 500 homework assignments on the platform.',

  'achievement.student.set_avatar.title': 'Say Cheese!',
  'achievement.student.set_avatar.desc':
    'Reward for setting or changing your profile avatar',

  'achievement.student.first_olimpic.title': 'Just Give It a Try!',
  'achievement.student.first_olimpic.desc':
    'Congratulations on participating in your first olympiad!',

  'achievement.student.olimpic_prize_place.title': 'Bring Me the Prize!',
  'achievement.student.olimpic_prize_place.desc':
    'Congratulations on winning a prize place in the olympiad!',

  'achievement.student.olimpic_first_place.title': 'The Best of All!',
  'achievement.student.olimpic_first_place.desc':
    'Congratulations on winning first place in the olympiad!',

  'achievement.student.first_exam_access.title': 'I’m Ready!',
  'achievement.student.first_exam_access.desc':
    'You’ve taken your first exam — well done!',

  'achievement.student.access_3_month.title': 'Together We March!',
  'achievement.student.access_3_month.desc':
    'Hooray! You’ve been learning with us for 3 months in a row.',

  'achievement.student.access_6_month.title': 'Six Months Like a Day',
  'achievement.student.access_6_month.desc':
    'Hooray! You’ve been learning with us for 6 months in a row.',

  'achievement.student.access_12_month.title': 'I Won’t Turn Back...',
  'achievement.student.access_12_month.desc':
    'Hooray! You’ve been learning with us for a whole year.',

  'achievement.student.student_try_uamap.title':
    'I Want to Do More Than Just Watch!',
  'achievement.student.student_try_uamap.desc':
    'Reward for your first attempt at simulating a UAMAP exam',

  'achievement.student.student_try_sama_mental.title':
    'The Mental Journey Begins...',
  'achievement.student.student_try_sama_mental.desc':
    'Reward for your first attempt at simulating a PAMA GLOBAL Mental exam',

  'achievement.student.student_try_sama_abacus.title':
    'It All Started with an Abacus...',
  'achievement.student.student_try_sama_abacus.desc':
    'Reward for your first attempt at simulating a PAMA GLOBAL Abacus exam',

  'achievement.student.uamap_13.title': 'UAMAP Medal Level 13',
  'achievement.student.uamap_13.desc':
    'Congratulations! You passed the UAMAP Level 13 exam!',

  'achievement.student.uamap_12.title': 'UAMAP Medal Level 12',
  'achievement.student.uamap_12.desc':
    'Congratulations! You passed the UAMAP Level 12 exam!',

  'achievement.student.uamap_11.title': 'UAMAP Medal Level 11',
  'achievement.student.uamap_11.desc':
    'Congratulations! You passed the UAMAP Level 11 exam!',

  'achievement.student.uamap_10.title': 'UAMAP Medal Level 10',
  'achievement.student.uamap_10.desc':
    'Congratulations! You passed the UAMAP Level 10 exam!',

  'achievement.student.uamap_9.title': 'UAMAP Medal Level 9',
  'achievement.student.uamap_9.desc':
    'Congratulations! You passed the UAMAP Level 9 exam!',

  'achievement.student.uamap_8.title': 'UAMAP Medal Level 8',
  'achievement.student.uamap_8.desc':
    'Congratulations! You passed the UAMAP Level 8 exam!',

  'achievement.student.uamap_7.title': 'UAMAP Medal Level 7',
  'achievement.student.uamap_7.desc':
    'Congratulations! You passed the UAMAP Level 7 exam!',

  'achievement.student.uamap_6.title': 'UAMAP Medal Level 6',
  'achievement.student.uamap_6.desc':
    'Congratulations! You passed the UAMAP Level 6 exam!',

  'achievement.student.sama_abacus_12.title':
    'PAMA GLOBAL Abacus Order Level 12',
  'achievement.student.sama_abacus_12.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 12 exam!',

  'achievement.student.sama_abacus_11.title':
    'PAMA GLOBAL Abacus Order Level 11',
  'achievement.student.sama_abacus_11.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 11 exam!',

  'achievement.student.sama_abacus_10.title':
    'PAMA GLOBAL Abacus Order Level 10',
  'achievement.student.sama_abacus_10.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 10 exam!',

  'achievement.student.sama_abacus_9.title': 'PAMA GLOBAL Abacus Order Level 9',
  'achievement.student.sama_abacus_9.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 9 exam!',

  'achievement.student.sama_abacus_8.title': 'PAMA GLOBAL Abacus Order Level 8',
  'achievement.student.sama_abacus_8.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 8 exam!',

  'achievement.student.sama_abacus_7.title': 'PAMA GLOBAL Abacus Order Level 7',
  'achievement.student.sama_abacus_7.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 7 exam!',

  'achievement.student.sama_abacus_6.title': 'PAMA GLOBAL Abacus Order Level 6',
  'achievement.student.sama_abacus_6.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 6 exam!',

  'achievement.student.sama_abacus_5.title': 'PAMA GLOBAL Abacus Order Level 5',
  'achievement.student.sama_abacus_5.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 5 exam!',

  'achievement.student.sama_abacus_4.title': 'PAMA GLOBAL Abacus Order Level 4',
  'achievement.student.sama_abacus_4.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 4 exam!',

  'achievement.student.sama_abacus_3.title': 'PAMA GLOBAL Abacus Order Level 3',
  'achievement.student.sama_abacus_3.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 3 exam!',

  'achievement.student.sama_abacus_2.title': 'PAMA GLOBAL Abacus Order Level 2',
  'achievement.student.sama_abacus_2.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 2 exam!',

  'achievement.student.sama_abacus_1.title': 'PAMA GLOBAL Abacus Order Level 1',
  'achievement.student.sama_abacus_1.desc':
    'Congratulations! You passed the PAMA GLOBAL Abacus Level 1 exam!',

  'achievement.student.sama_mental_12.title':
    'PAMA GLOBAL Mental Crown Level 12',
  'achievement.student.sama_mental_12.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 12 exam!',

  'achievement.student.sama_mental_11.title':
    'PAMA GLOBAL Mental Crown Level 11',
  'achievement.student.sama_mental_11.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 11 exam!',

  'achievement.student.sama_mental_10.title':
    'PAMA GLOBAL Mental Crown Level 10',
  'achievement.student.sama_mental_10.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 10 exam!',

  'achievement.student.sama_mental_9.title': 'PAMA GLOBAL Mental Crown Level 9',
  'achievement.student.sama_mental_9.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 9 exam!',

  'achievement.student.sama_mental_8.title': 'PAMA GLOBAL Mental Crown Level 8',
  'achievement.student.sama_mental_8.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 8 exam!',

  'achievement.student.sama_mental_7.title': 'PAMA GLOBAL Mental Crown Level 7',
  'achievement.student.sama_mental_7.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 7 exam!',

  'achievement.student.sama_mental_6.title': 'PAMA GLOBAL Mental Crown Level 6',
  'achievement.student.sama_mental_6.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 6 exam!',

  'achievement.student.sama_mental_5.title': 'PAMA GLOBAL Mental Crown Level 5',
  'achievement.student.sama_mental_5.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 5 exam!',

  'achievement.student.sama_mental_4.title': 'PAMA GLOBAL Mental Crown Level 4',
  'achievement.student.sama_mental_4.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 4 exam!',

  'achievement.student.sama_mental_3.title': 'PAMA GLOBAL Mental Crown Level 3',
  'achievement.student.sama_mental_3.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 3 exam!',

  'achievement.student.sama_mental_2.title': 'PAMA GLOBAL Mental Crown Level 2',
  'achievement.student.sama_mental_2.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 2 exam!',

  'achievement.student.sama_mental_1.title': 'PAMA GLOBAL Mental Crown Level 1',
  'achievement.student.sama_mental_1.desc':
    'Congratulations! You passed the PAMA GLOBAL Mental Level 1 exam!',

  // teacher
  'achievement.teacher.first_student_exam_completed.title':
    'The First One’s Off!',
  'achievement.teacher.first_student_exam_completed.desc':
    '1 student passed any exam',

  'achievement.teacher.10_student_exams_completed.title': 'Team Builder!',
  'achievement.teacher.10_student_exams_completed.desc':
    '10 students passed any exam',

  'achievement.teacher.50_student_exams_completed.title': 'The Mentor',
  'achievement.teacher.50_student_exams_completed.desc':
    '50 students passed any exam',

  'achievement.teacher.homeworks_for_week_comleted.title':
    'Setting the Example',
  'achievement.teacher.homeworks_for_week_comleted.desc':
    'Congratulations! Your student completed all homework for a full week!',

  'achievement.teacher.olimpic_prize_1.title': 'Sharing the Knowledge',
  'achievement.teacher.olimpic_prize_1.desc':
    'Congratulations! One of your students won a prize in the olympiad!',

  'achievement.teacher.olimpic_prize_3.title': 'Sensei',
  'achievement.teacher.olimpic_prize_3.desc':
    'Congratulations! 3 of your students won prizes in the olympiad!',

  'achievement.teacher.olimpic_prize_5.title': 'Wise Teacher',
  'achievement.teacher.olimpic_prize_5.desc':
    'Congratulations! 5 of your students won prizes in the olympiad!',

  'achievement.teacher.10_homeworks_created.title': 'No Time to Rest!',
  'achievement.teacher.10_homeworks_created.desc':
    'Nice! You’ve assigned 10 homework tasks to your students.',

  'achievement.teacher.100_homeworks_created.title': 'Know My Craft!',
  'achievement.teacher.100_homeworks_created.desc':
    'Nice! You’ve assigned 100 homework tasks to your students.',

  'achievement.teacher.500_homeworks_created.title': 'More Is Better!',
  'achievement.teacher.500_homeworks_created.desc':
    'Nice! You’ve assigned 500 homework tasks to your students.',

  'achievement.teacher.referal_created_student_1.title': '(+1)',
  'achievement.teacher.referal_created_student_1.desc':
    'Congratulations! You’ve invited a new student to the platform!',

  'achievement.teacher.referal_created_student_5.title':
    'Together We’re Stronger',
  'achievement.teacher.referal_created_student_5.desc':
    'Congratulations! You’ve invited 5 students to the platform!',

  'achievement.teacher.referal_created_student_10.title': 'We Are a Team!',
  'achievement.teacher.referal_created_student_10.desc':
    'Congratulations! You’ve invited 10 students to the platform!',

  'achievement.teacher.referal_created_teacher_1.title': 'Not Alone Anymore!',
  'achievement.teacher.referal_created_teacher_1.desc':
    'Congratulations! You’ve invited a new teacher to the platform!',

  'achievement.teacher.referal_created_teacher_3.title': 'All Family Here!',
  'achievement.teacher.referal_created_teacher_3.desc':
    'Congratulations! You’ve invited 3 teachers to the platform!',

  'achievement.teacher.referal_created_teacher_5.title': 'Love My Job!',
  'achievement.teacher.referal_created_teacher_5.desc':
    'Congratulations! You’ve invited 5 teachers to the platform!',

  'achievement.teacher.pay_for_student_access.title': 'Investing in the Future',
  'achievement.teacher.pay_for_student_access.desc':
    'You’ve just paid for your student’s platform subscription — here’s your reward!',

  'achievement.teacher.pay_for_student_olimpic.title': 'Showing Care',
  'achievement.teacher.pay_for_student_olimpic.desc':
    'You’ve just paid for your student’s olympiad participation — here’s your reward!',

  'achievement.teacher.topup_account.title': 'Will Come in Handy!',
  'achievement.teacher.topup_account.desc':
    'You’ve topped up your account — enjoy a small gift!',

  'achievement.teacher.set_avatar.title': 'Say Cheese!',
  'achievement.teacher.set_avatar.desc':
    'Reward for setting or changing your profile avatar',

  'achievement.teacher.complete_profile.title': 'One of Us!',
  'achievement.teacher.complete_profile.desc':
    'Reward for filling in all profile fields',

  'achievement.teacher.uamap_1.title': 'UAMAP Certificate Level 1',
  'achievement.teacher.uamap_1.desc':
    'Congratulations! You passed the UAMAP Level 1 exam',

  'achievement.teacher.uamap_2.title': 'UAMAP Certificate Level 2',
  'achievement.teacher.uamap_2.desc':
    'Congratulations! You passed the UAMAP Level 2 exam',

  'achievement.teacher.uamap_3.title': 'UAMAP Certificate Level 3',
  'achievement.teacher.uamap_3.desc':
    'Congratulations! You passed the UAMAP Level 3 exam',

  'achievement.teacher.sama_3.title': '3 Stars PAMA GLOBAL',
  'achievement.teacher.sama_3.desc':
    'Congratulations! You’ve earned 3 stars in PAMA GLOBAL',

  'achievement.teacher.sama_5.title': '2 Stars PAMA GLOBAL',
  'achievement.teacher.sama_5.desc':
    'Congratulations! You’ve earned 2 stars in PAMA GLOBAL',

  'achievement.teacher.sama_7.title': '1 Star PAMA GLOBAL',
  'achievement.teacher.sama_7.desc':
    'Congratulations! You’ve earned 1 star in PAMA GLOBAL',

  // other

  SOUND_ON: 'on',
  DAILY: 'Daily',
  COMPLETE_BY: 'Complete by',
  SPECIFIC_DAYS: 'Specific days',
  SPECIFIC_DAYS_MULTIPLE: 'Specific days (multiple dates allowed)',

  MONTHS_LIST:
    'January,February,March,April,May,June,July,August,September,October,November,December',
  MONTHS_SHORT: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
  WEEKDAYS_LONG: 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday',
  WEEKDAYS_SHORT: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat',
  NEXT_MONTH: 'next month',
  PREVIOUS_MONTH: 'previous month',
  GENDER_MALE: 'Male',
  GENDER_FEMALE: 'Female',
  THEME_STANDARD: 'Standard',
  THEME_STANDARD_DESC: 'Themes available to all users',
  THEME_UNIQUE: 'Unique',
  THEME_UNIQUE_DESC: 'Themes available for magic feathers',
  BRAND_THEME: 'Brand Theme',
  ABACUS_COLOR_CHOICE: 'Here you can choose the color of beads for your abacus',
  EGYPT_THEME_DESC:
    'Explore magical ancient Egypt with pyramids, pharaohs, and hidden treasures!',
  INSTALL: 'Use',
  OWL_GREETING: 'Hello, my name is Uni the owl',
  CONFIGURE_TRAINER: 'Configure trainer',
  CHOOSE_TASK_TEXT: 'Choose a suitable task and amaze me with your results',
  QUICK_START: 'Quick start',
  QUICK_START_DESC: 'Click to train right now with a set of random settings',
  TABLE_SIZE: 'Table size',
  NUMBER_DIGITS: 'Number of digits',
  SHUFFLE_ON_CLICK: 'Shuffle on click',
  CENTER_DOT: 'Center dot',
  SYMBOL_ORDER: 'Symbol order',
  TABLE_TYPE: 'Table type',
  DIRECT_ORDER: 'Direct',
  REVERSE_ORDER: 'Reverse',
  RANDOM_ORDER: 'Random',
  NUMBERS: 'Numbers',
  SOUND_VOLUME: 'Sound volume',
  FIND_SYMBOL: 'Find the symbol',
  // other
  DIGIT_RANGE: 'Digit range',
  FOR_WHOM: 'For whom',
  REDUCE_TABLE: 'Make table smaller',
  // correct or wrong phrases when user solves samples
  OWL_SUCCESS_1: 'When you solve the problem correctly',
  OWL_SUCCESS_2: 'Simply excellent',
  OWL_SUCCESS_3: 'Ha, easy peasy!',
  OWL_SUCCESS_4: "You're incredibly awesome",
  OWL_SUCCESS_5: 'Answer is correct',
  OWL_SUCCESS_6: 'Excellent work',
  OWL_SUCCESS_7: 'Got a perfect score',
  OWL_SUCCESS_8: "That's just awesome!",
  OWL_SUCCESS_9: 'You did it?!',
  OWL_SUCCESS_10: 'Super smart',
  OWL_SUCCESS_11: "Let's keep going!",
  OWL_SUCCESS_12: 'Nailed it!',
  OWL_SUCCESS_13: 'Easy win',
  OWL_SUCCESS_14: 'YOSH!',
  OWL_SUCCESS_15: 'Incredible!',
  OWL_SUCCESS_16: 'You did it!',
  OWL_SUCCESS_17: 'The sharpest answer in the Wild West',
  OWL_SUCCESS_18: 'Humanity has never been this close to perfection!',

  OWL_FAILED_1: 'Unfortunately, no…',
  OWL_FAILED_2: "Looks like someone's too chill today",
  OWL_FAILED_3: 'Oh my god',
  OWL_FAILED_4: 'Answer is incorrect…',
  OWL_FAILED_5: 'Are you sure you signed up for mental arithmetic?',
  OWL_FAILED_6: 'Wrong approach',
  OWL_FAILED_7: 'Nope!',
  OWL_FAILED_8: 'Another try?',
  OWL_FAILED_9: 'I disapprove',
  OWL_FAILED_10: "Don't be upset...",
  OWL_FAILED_11: 'Try again…',
  OWL_FAILED_12: 'I really believed in you...',
  OWL_FAILED_13: 'Again...',
  OWL_FAILED_14: 'If you struggle long enough, something will work out!',
  OWL_FAILED_15: 'Well, shoot',
  OWL_FAILED_16: 'Years of effort, mountains of trying, all for this',
  OWL_FAILED_17: 'What could have gone wrong this time?',
  OWL_FAILED_18: 'Next time it will work!',
  // other
  FULLSCREEN: 'Fullscreen',
  EXIT_FULLSCREEN: 'Exit fullscreen',
  CURRENT_RANK: 'Your current rank:',
  PAST_WINNERS: 'Past winners',
  WINNER_TABLE_CREATE_TITLE: 'Add new winner',
  EDIT_WINNER_TITLE: 'Edit winner',
  CHOOSE_OLIMPIC_NAME: 'Choose competition',
  CONFIRM_DELETE_WINNER: "Are you sure you want to delete the winner's record?",
  FILE_SIZE_ERROR: 'Please select a photo no larger than 3MB',
  FILE_TYPE_ERROR:
    'Invalid file type. Please upload an image (JPEG, PNG, etc.)',
  SAVE_WINNERS_RESULT: 'Save results',
  CONFIRM_SAVE_WINNERS:
    'Are you sure you want to save the results? IMPORTANT! Places must be assigned.',
  NO_PLACES_WARNING: 'No places 0/1 specified!',
  IMPORTANT_FIELDS_LOCKED:
    'Name, surname, and date of birth can only be changed once. Please contact the administrator for assistance.',
  LOGIN_CHANGE_CONFIRM:
    'After editing your email in the profile, the login email for your account has changed.',
  TEMPLATES: 'Templates',
  CATEGORY_NAME_VALIDATION:
    'Category name must contain only uppercase Latin letters and numbers',
  DIPLOMS_RECORDS_TEMPLATES: 'Templates for Diploma Records',
  MAIN_TEMPLATE: 'Default Template',
  CONFIRM_DELETE_TEMPLATE: 'Are you sure you want to delete this template?',
  TEMPLATE_CREATE_TITLE: 'Create Template',
  TEMPLATE_EDIT_TITLE: 'Edit Template',
  TEMPLATE_SUCCESS_CREATE_MESSAGE: 'Template has been successfully created',
  TEMPLATE_SUCCESS_EDIT_MESSAGE: 'Template has been successfully updated',
  ADD_STAGE: 'Add Stage',
  ADD_CATEGORY: 'Add Category',
  VARIANT: 'Counting Type',
  SHORT_RECORD: 'Short Record',
  CATEGORY_NAME: 'Category Name',
  SAMPLES_TYPE: 'Task Type',
  TEMPLATE_FORM_TEXT: 'Select a template for diploma records',
  // Рейтинг звезд
  BEST_STUDENTS: 'BEST STUDENTS',
  RESET_STARS: 'Reset stars',
  OPEN_ALL: 'View all',
  LOADING: 'Loading...',
  TAB_IN_SCHOOL: 'School',
  TAB_WITH_TEACHER: "Teacher's",
  TAB_IN_GROUP: 'Group',
  NO_RATING_DATA: 'No students in rating yet',
  SCHOOL_STAR_RATING: 'School rating',
  GROUPS_STAR_RATING: 'Rating by group',
  TEACHER_STAR_RATING: 'Rating by teacher',
  CONFIRM_RESET_STARS:
    'Are you sure you want to reset stars for all your students?',
  CONFIRM_RESET_SCHOOL_STARS:
    'Are you sure you want to reset stars for these students?',
  RATING_SCHOOL_MESSAGE:
    'Select students (your own and teachers) to reset stars',
  NO_TEACHERS: 'No teachers found',
  STAR_RATING_CLUE:
    "Stars for your students' homework. You can reward students at your discretion, thereby increasing children's motivation. Prizes, dates for summing up results and the number of places are at your discretion.",
  SETTING_ON: 'on',
  SMGL_USERS_TITLE: 'PAMA users',
  OPERATION_COMPLETED: 'Operation completed successfully',
  DELETED_COUNT: 'Users deleted: {count}',
  SHOW_RATING_FOR_UAMAP: 'Show rating on Uamap',
  PAMA_GLOBAL_RATING: 'PAMA Global Rating',
  SHOW_IN_ROW: 'Show in a row',
  PAMA_GLOBAL_PRINT: 'Print PAMA Global tasks',
  PAMA_OFFLINE_OLIMPIC: 'PAMA Global Offline',
  PAMA_OFFLINE_FOR_STUDENT: 'PAMA Global Offline for Student',
  PAMA_OFFLINE_FOR_TEACHER: 'PAMA GlobalOffline for Teacher',
  MAINTAINER_PAMA: 'PAMA Global Maintainer',
  PAMA_OFFLINE_PARTICIPANTS: 'PAMA Global Offline Participants',
  PAMA_OFFLINE_OLIMPIC_PAYMENT:
    'PAMA GLOBAL in-person competition participation purchase',
  MAINTAINER_PAMA_PAYMENT: 'Companion to PAMA GLOBAL in-person competition',
  PAMA_OFFLINE_OLIMPIC_PAY_PARTICIPATE:
    'Pay for PAMA Global in-person competition participation',
  // ..
  PRACTICE_ON_TAB: 'Practice on the tab',
  WITH_ACTIVE_ACCESS: 'with active access on our platform',
  ACCOMPANY_PARTICIPANT_TEXT:
    'If you plan to accompany the participant, please purchase a ticket for them as well.',
  CURRENT_COMPANION_LIMIT: 'Current companion limit:',
  COMPANION_SALES_CLOSED: 'Companion ticket sales are closed.',
  PURCHASED_TEXT: 'Purchased:',
  COMPANION_TICKET_ONE: 'ticket',
  COMPANION_TICKET_TWO: 'tickets',
  COMPANION_TICKET_FIVE: 'tickets',
  OF_COMPANIONS: 'for companions',
  TICKET_DATA_WARNING:
    'The following data will be used to create the ticket, please check for accuracy',
  TICKET_EMAIL_DELIVERY_PAMA:
    'The ticket will be sent to the specified email address within the designated timeframe.',
  TICKET_EMAIL_DELIVERY_OLIMPIC:
    'The ticket will be sent to the specified email address within 3-5 business days. If this has not happened, please contact us via',
  TELEGRAM_LINK_TEXT: 'Telegram',
  EDIT_PROFILE_IF_ERROR: 'In case of an error, please edit your profile',
  PHOTO_UPLOAD_NOTICE:
    'Upload a photo (max 10 MB) to any cloud storage. Copy the link and paste it here. Make sure the link has open access.',
  SELECT_CATEGORY_PLACEHOLDER: 'Select a category',
  SELECT_COUNTRY_PLACEHOLDER: 'Select a country',
  RULES_AGREEMENT:
    'I have read the competition regulations and accept all the rules described therein.',
  CATEGORY_WARNING:
    'Choose a category strictly higher if you have previously won a prize. There may be disqualifications if the rules are not followed.',
  MAINTAINERS_LIMIT_REACHED: 'Maximum number of companions reached.',
  STUDENT_TABLE_REGISTER_NOTICE:
    'Please register the user for the competition in their personal account',
  COMPANION_REGISTRATION_REQUIRED:
    'Registration for the competition is required to purchase',
  MAINTAINERS_ONE_PURCHASE: '1 Companion / Purchase',
  MAINTAINERS_OTHER_PURCHASE: '{count} Companions / Purchase',
  OFFICIAL_MODE: 'Activate official PAMA samples',
  NUMBERS_TITLE: 'Memory Numbers',
  LENGTH_WORD: 'Length',
  DIGITS_SHORT: 'dig.',
  PROGRESS_WORD: 'Progress',
  WRITE_ANSWER_INTERMEDIATE: 'Write your answer! New number in...',
  WRITE_ANSWER: 'Write your answer!',
  PAUSE: 'Pause',
  CHECK_ANSWERS: 'Check your answers.',
  STAGE_FINISHED: 'Stage completed!',
  NUMBER_WORD: 'Number',
  buy_books: 'Buy textbooks',
  CHAMPION_OF_CHAMPIONS: 'Champion of Champions',
  // new
  MAINTAINERS_REGISTRATION_FORM: 'Maintainers registration form',
  REGISTER_MAINTAINERS: 'Register maintainers',
  HIDE_MAINTAINERS_FORM: 'Hide maintainers form',
  MAINTAINERS_SUCCESS_SAVED: 'Maintainers successfully registered',
  PHOTO_LINK_MAINTAINER: 'Maintainer photo link',
  RELATION: 'Role',
  RELATION_PARENT: 'Parent',
  RELATION_TEACHER: 'Teacher',
  MAINTAINERS_FILL_ALL_FIELDS:
    'Fill in all required fields for at least one maintainer',
  MAINTAINERS: 'Maintainers',
  MAINTAINERS_LOADED_COUNT: 'Maintainers loaded: {count}',
  UNFILLED_MAINTAINERS: 'Unreg. maintainers',
  EDIT_MAINTAINER: 'Edit maintainer',
  CONFIRM_DELETE_MAINTAINER:
    "Are you sure you want to delete this maintainer? The participant's maintainer ticket counter will be decreased by 1.",
  FULL_NAME_EN: 'Full name in English',
  DONT_SHOW_AGAIN: "Don't show again",
  PRINT_ALL_STAGES: 'Print all stages at once',
};
